
import React, { useState, useEffect, useRef, useCallback, useContext } from 'react';
import * as sdk from 'microsoft-cognitiveservices-speech-sdk';
import * as microsoftTeams from "@microsoft/teams-js";
import UserContext from '../context/UserContext';
import '../styles/WebVoiceTranslator.css';
import { MeetingContext } from './MeetingContext';

// Sabit tanımlamalar
const SPEECH_KEY = '9qBhM45nuEmfzTDDTyJFSl0j7e8f317z9z3BUxTrbhD1qL4H8dFMJQQJ99AJAC5RqLJXJ3w3AAAYACOGfJHi';
const SPEECH_REGION = 'westeurope';
const TRANSLATOR_KEY = 'AAzgUJTaz9kanUktd6RBCeLugLFAwcV450bH2Ho2xsq4potwPzhaJQQJ99AJAC5RqLJXJ3w3AAAbACOG4sRG';
const TRANSLATOR_REGION = 'westeurope';
const API_BASE_URL = 'https://cscvoiceapi.azurewebsites.net';
const DISPLAY_DURATION = 1800000;
const DEFAULT_USER_NAME = 'Misafir Kullanıcı';

// Sektör ve Departman Bilgileri - Dosyanın üst kısmına ekleyin
const INDUSTRY_SECTORS = [
  { id: 'technology', name: 'Teknoloji', icon: '💻' },
  { id: 'finance', name: 'Finans', icon: '💰' },
  { id: 'healthcare', name: 'Sağlık', icon: '🏥' },
  { id: 'education', name: 'Eğitim', icon: '🎓' },
  { id: 'manufacturing', name: 'Üretim', icon: '🏭' },
  { id: 'retail', name: 'Perakende', icon: '🛒' },
  { id: 'consulting', name: 'Danışmanlık', icon: '📊' },
  { id: 'construction', name: 'İnşaat', icon: '🏗️' },
  { id: 'energy', name: 'Enerji', icon: '⚡' },
  { id: 'logistics', name: 'Lojistik', icon: '🚚' }
];

const DEPARTMENTS = [
  { id: 'executive', name: 'Üst Yönetim', icon: '👑' },
  { id: 'sales', name: 'Satış', icon: '🤝' },
  { id: 'marketing', name: 'Pazarlama', icon: '📢' },
  { id: 'hr', name: 'İnsan Kaynakları', icon: '👥' },
  { id: 'it', name: 'Bilgi Teknolojileri', icon: '🖥️' },
  { id: 'rd', name: 'AR-GE', icon: '🔬' }
];

// Desteklenen diller
const SUPPORTED_LANGUAGES = [
  { 
    code: 'tr-TR', 
    name: 'Türkçe', 
    shortCode: 'tr',
    icon: '🇹🇷',
    phraseList: ['merhaba', 'günaydın', 'iyi akşamlar']
  },
  { 
    code: 'en-US', 
    name: 'İngilizce', 
    shortCode: 'en',
    icon: '🇺🇸',
    phraseList: ['hello', 'good morning', 'good evening']
  },
  { 
    code: 'ru-RU', 
    name: 'Rusça', 
    shortCode: 'ru',
    icon: '🇷🇺',
    phraseList: ['привет', 'доброе утро', 'добрый вечер']
  },
  { 
    code: 'es-ES', 
    name: 'İspanyolca', 
    shortCode: 'es',
    icon: '🇪🇸',
    phraseList: ['hola', 'buenos días', 'buenas noches']
  },
  { 
    code: 'it-IT', 
    name: 'İtalyanca', 
    shortCode: 'it',
    icon: '🇮🇹',
    phraseList: ['ciao', 'buongiorno', 'buonasera']
  },
  { 
    code: 'de-DE', 
    name: 'Almanca', 
    shortCode: 'de',
    icon: '🇩🇪',
    phraseList: ['hallo', 'guten Morgen', 'guten Abend']
  },
  { 
    code: 'pt-PT', 
    name: 'Portekizce', 
    shortCode: 'pt',
    icon: '🇵🇹',
    phraseList: ['olá', 'bom dia', 'boa noite']
  },
  { 
    code: 'zh-CN', 
    name: 'Çince', 
    shortCode: 'zh',
    icon: '🇨🇳',
    phraseList: ['你好', '早上好', '晚上好']
  },
  { 
    code: 'he-IL', 
    name: 'İbranice', 
    shortCode: 'he',
    icon: '🇮🇱',
    phraseList: ['שלום', 'בוקר טוב', 'ערב טוב']
  },
  { 
    code: 'fr-FR', 
    name: 'Fransızca', 
    shortCode: 'fr',
    icon: '🇫🇷',
    phraseList: ['bonjour', 'bonsoir', 'bonne nuit']
  },
  { 
    code: 'el-GR', 
    name: 'Yunanca', 
    shortCode: 'el',
    icon: '🇬🇷',
    phraseList: ['γειά', 'καλημέρα', 'καλησπέρα']
  },
  { 
    code: 'ar-SA', 
    name: 'Arapça', 
    shortCode: 'ar',
    icon: '🇸🇦',
    phraseList: ['مرحباً', 'صباح الخير', 'مساء الخير']
  },
  { 
    code: 'bg-BG', 
    name: 'Bulgarca', 
    shortCode: 'bg',
    icon: '🇧🇬',
    phraseList: ['здравейте', 'добро утро', 'добър вечер']
  },
  { 
    code: 'cs-CZ', 
    name: 'Çekçe', 
    shortCode: 'cs',
    icon: '🇨🇿',
    phraseList: ['ahoj', 'dobré ráno', 'dobrý večer']
  },
  { 
    code: 'da-DK', 
    name: 'Danca', 
    shortCode: 'da',
    icon: '🇩🇰',
    phraseList: ['hej', 'godmorgen', 'god aften']
  },
  { 
    code: 'fi-FI', 
    name: 'Fince', 
    shortCode: 'fi',
    icon: '🇫🇮',
    phraseList: ['hei', 'hyvää huomenta', 'hyvää iltaa']
  },
  { 
    code: 'hu-HU', 
    name: 'Macarca', 
    shortCode: 'hu',
    icon: '🇭🇺',
    phraseList: ['helló', 'jó reggelt', 'jó estét']
  },
  { 
    code: 'ja-JP', 
    name: 'Japonca', 
    shortCode: 'ja',
    icon: '🇯🇵',
    phraseList: ['こんにちは', 'おはよう', 'こんばんは']
  },
  { 
    code: 'ko-KR', 
    name: 'Korece', 
    shortCode: 'ko',
    icon: '🇰🇷',
    phraseList: ['안녕하세요', '좋은 아침', '좋은 저녁']
  },
  { 
    code: 'pl-PL', 
    name: 'Lehçe', 
    shortCode: 'pl',
    icon: '🇵🇱',
    phraseList: ['cześć', 'dzień dobry', 'dobry wieczór']
  },
  { 
    code: 'ro-RO', 
    name: 'Rumence', 
    shortCode: 'ro',
    icon: '🇷🇴',
    phraseList: ['bună', 'bună dimineața', 'bună seara']
  },
  { 
    code: 'sv-SE', 
    name: 'İsveççe', 
    shortCode: 'sv',
    icon: '🇸🇪',
    phraseList: ['hej', 'god morgon', 'god kväll']
  },
  { 
    code: 'uk-UA', 
    name: 'Ukraynaca', 
    shortCode: 'uk',
    icon: '🇺🇦',
    phraseList: ['привіт', 'добрий ранок', 'добрий вечір']
  },
  { 
    code: 'vi-VN', 
    name: 'Vietnamca', 
    shortCode: 'vi',
    icon: '🇻🇳',
    phraseList: ['xin chào', 'chào buổi sáng', 'chào buổi tối']
  },
  { 
    code: 'th-TH', 
    name: 'Taylandca', 
    shortCode: 'th',
    icon: '🇹🇭',
    phraseList: ['สวัสดี', 'สวัสดีตอนเช้า', 'สวัสดีตอนเย็น']
  },
  { 
    code: 'ms-MY', 
    name: 'Malayca', 
    shortCode: 'ms',
    icon: '🇲🇾',
    phraseList: ['halo', 'selamat pagi', 'selamat petang']
  }
];


const TRANSLATIONSREPORT = {
  'ar-SA': {
  title: "تقرير الاجتماع",
  summary: "ملخص الاجتماع",
  generatedAt: "تم الإنشاء في",
  stats: {
    totalParticipants: "إجمالي المشاركين",
    totalMessages: "إجمالي الرسائل",
    totalWords: "إجمالي الكلمات",
    duration: "مدة الاجتماع",
    minutes: "دقيقة"
  },
  participants: {
    title: "تفاصيل المشاركين",
    columns: {
      name: "المشارك",
      messageCount: "عدد الرسائل",
      wordCount: "عدد الكلمات",
      participation: "نسبة المشاركة"
    }
  },
  mood: {
    title: "أجواء الاجتماع",
    overall: "الحالة العامة",
    ambiance: "أجواء الاجتماع",
    reactions: "ردود الفعل المستخدمة",
    positive: "إيجابي",
    neutral: "محايد",
    negative: "سلبي",
    perParticipant: "الحالة لكل مشارك",
    keywords: "العبارات البارزة"
  },
  footer: {
    generatedBy: "تم إنشاء هذا التقرير تلقائيًا بواسطة CSC Voice AI",
    copyright: "© CSC Bilisim"
  }
},
'bg-BG': {
  title: "Доклад от срещата",
  summary: "Обобщение на срещата",
  generatedAt: "Генерирано на",
  stats: {
    totalParticipants: "Общо участници",
    totalMessages: "Общо съобщения",
    totalWords: "Общо думи",
    duration: "Продължителност на срещата",
    minutes: "минути"
  },
  participants: {
    title: "Детайли за участниците",
    columns: {
      name: "Участник",
      messageCount: "Брой съобщения",
      wordCount: "Брой думи",
      participation: "Степен на участие"
    }
  },
  mood: {
    title: "Атмосфера на срещата",
    overall: "Общо настроение",
    ambiance: "Атмосфера на срещата",
    reactions: "Използвани реакции",
    positive: "Позитивно",
    neutral: "Неутрално",
    negative: "Негативно",
    perParticipant: "Настроение по участници",
    keywords: "Подчертани изрази"
  },
  footer: {
    generatedBy: "Този доклад е автоматично генериран от CSC Voice AI",
    copyright: "© CSC Bilisim"
  }
},
'cs-CZ': {
  title: "Zpráva ze schůzky",
  summary: "Shrnutí schůzky",
  generatedAt: "Vytvořeno",
  stats: {
    totalParticipants: "Celkem účastníků",
    totalMessages: "Celkem zpráv",
    totalWords: "Celkem slov",
    duration: "Doba trvání schůzky",
    minutes: "minut"
  },
  participants: {
    title: "Detaily účastníků",
    columns: {
      name: "Účastník",
      messageCount: "Počet zpráv",
      wordCount: "Počet slov",
      participation: "Míra účasti"
    }
  },
  mood: {
    title: "Atmosféra schůzky",
    overall: "Celková nálada",
    ambiance: "Atmosféra schůzky",
    reactions: "Použité reakce",
    positive: "Pozitivní",
    neutral: "Neutrální",
    negative: "Negativní",
    perParticipant: "Nálada podle účastníků",
    keywords: "Zvýrazněné výrazy"
  },
  footer: {
    generatedBy: "Tato zpráva byla automaticky vygenerována pomocí CSC Voice AI",
    copyright: "© CSC Bilisim"
  }
},
'da-DK': {
  title: "Møderefereat",
  summary: "Mødesammenfatning",
  generatedAt: "Genereret den",
  stats: {
    totalParticipants: "Samlet antal deltagere",
    totalMessages: "Samlet antal beskeder",
    totalWords: "Samlet antal ord",
    duration: "Mødets varighed",
    minutes: "minutter"
  },
  participants: {
    title: "Deltagerdetaljer",
    columns: {
      name: "Deltager",
      messageCount: "Antal beskeder",
      wordCount: "Antal ord",
      participation: "Deltagelsesgrad"
    }
  },
  mood: {
    title: "Mødeatmosfære",
    overall: "Samlet stemning",
    ambiance: "Mødeatmosfære",
    reactions: "Anvendte reaktioner",
    positive: "Positiv",
    neutral: "Neutral",
    negative: "Negativ",
    perParticipant: "Stemning pr. deltager",
    keywords: "Fremhævede udtryk"
  },
  footer: {
    generatedBy: "Denne rapport er automatisk genereret af CSC Voice AI",
    copyright: "© CSC Bilisim"
  }
},
'de-DE': {
  title: "Besprechungsbericht",
  summary: "Besprechungszusammenfassung",
  generatedAt: "Erstellt am",
  stats: {
    totalParticipants: "Gesamtteilnehmer",
    totalMessages: "Gesamtnachrichten",
    totalWords: "Gesamtwörter",
    duration: "Besprechungsdauer",
    minutes: "Minuten"
  },
  participants: {
    title: "Teilnehmerdetails",
    columns: {
      name: "Teilnehmer",
      messageCount: "Nachrichtenanzahl",
      wordCount: "Wortanzahl",
      participation: "Teilnahmequote"
    }
  },
  mood: {
    title: "Besprechungsatmosphäre",
    overall: "Gesamtstimmung",
    ambiance: "Besprechungsambiente",
    reactions: "Verwendete Reaktionen",
    positive: "Positiv",
    neutral: "Neutral",
    negative: "Negativ",
    perParticipant: "Stimmung pro Teilnehmer",
    keywords: "Hervorgehobene Ausdrücke"
  },
  footer: {
    generatedBy: "Dieser Bericht wurde automatisch von CSC Voice AI generiert",
    copyright: "© CSC Bilisim"
  }
},
  'el-GR': {
    title: "Αναφορά Συνάντησης",
    summary: "Περίληψη Συνάντησης",
    generatedAt: "Δημιουργήθηκε στις",
    stats: {
      totalParticipants: "Συνολικοί Συμμετέχοντες",
      totalMessages: "Συνολικά Μηνύματα",
      totalWords: "Συνολικές Λέξεις",
      duration: "Διάρκεια Συνάντησης",
      minutes: "λεπτά"
    },
    participants: {
      title: "Λεπτομέρειες Συμμετεχόντων",
      columns: {
        name: "Συμμετέχων",
        messageCount: "Αριθμός Μηνυμάτων",
        wordCount: "Αριθμός Λέξεων",
        participation: "Ποσοστό Συμμετοχής"
      }
    },
    mood: {
      title: "Ατμόσφαιρα Συνάντησης",
      overall: "Συνολική Διάθεση",
      ambiance: "Ατμόσφαιρα Συνάντησης",
      reactions: "Χρησιμοποιημένες Αντιδράσεις",
      positive: "Θετικό",
      neutral: "Ουδέτερο",
      negative: "Αρνητικό",
      perParticipant: "Διάθεση ανά Συμμετέχοντα",
      keywords: "Βασικές Εκφράσεις"
    },
    footer: {
      generatedBy: "Η αναφορά δημιουργήθηκε αυτόματα από το CSC Voice AI",
      copyright: "© CSC Bilisim"
    }
  },
  'en-US': {
    title: "Meeting Report",
    summary: "Meeting Summary",
    generatedAt: "Generated At",
    stats: {
      totalParticipants: "Total Participants",
      totalMessages: "Total Messages",
      totalWords: "Total Words",
      duration: "Meeting Duration",
      minutes: "minutes"
    },
    participants: {
      title: "Participant Details",
      columns: {
        name: "Participant",
        messageCount: "Message Count",
        wordCount: "Word Count",
        participation: "Participation Rate"
      }
    },
    mood: {
      title: "Meeting Mood",
      overall: "Overall Mood",
      ambiance: "Meeting Ambiance",
      reactions: "Used Reactions",
      positive: "Positive",
      neutral: "Neutral",
      negative: "Negative",
      perParticipant: "Mood Per Participant",
      keywords: "Highlighted Expressions"
    },
    footer: {
      generatedBy: "This report was automatically generated by CSC Voice AI",
      copyright: "© CSC Bilisim"
    }
  },
  'es-ES': {
    title: "Informe de la Reunión",
    summary: "Resumen de la Reunión",
    generatedAt: "Generado el",
    stats: {
      totalParticipants: "Total de Participantes",
      totalMessages: "Total de Mensajes",
      totalWords: "Total de Palabras",
      duration: "Duración de la Reunión",
      minutes: "minutos"
    },
    participants: {
      title: "Detalles de los Participantes",
      columns: {
        name: "Participante",
        messageCount: "Cantidad de Mensajes",
        wordCount: "Cantidad de Palabras",
        participation: "Porcentaje de Participación"
      }
    },
    mood: {
      title: "Ambiente de la Reunión",
      overall: "Estado General",
      ambiance: "Ambiente de la Reunión",
      reactions: "Reacciones Utilizadas",
      positive: "Positivo",
      neutral: "Neutral",
      negative: "Negativo",
      perParticipant: "Estado por Participante",
      keywords: "Expresiones Destacadas"
    },
    footer: {
      generatedBy: "Este informe fue generado automáticamente por CSC Voice AI",
      copyright: "© CSC Bilisim"
    }
  },
  'fi-FI': {
    title: "Kokousraportti",
    summary: "Kokouksen Yhteenveto",
    generatedAt: "Luotu",
    stats: {
      totalParticipants: "Osallistujien Määrä",
      totalMessages: "Viestien Määrä",
      totalWords: "Sanamäärä",
      duration: "Kokouksen Kesto",
      minutes: "minuuttia"
    },
    participants: {
      title: "Osallistujien Tiedot",
      columns: {
        name: "Osallistuja",
        messageCount: "Viestien Lukumäärä",
        wordCount: "Sanamäärä",
        participation: "Osallistumisaste"
      }
    },
    mood: {
      title: "Kokouksen Tunnelma",
      overall: "Yleinen Tunnelma",
      ambiance: "Kokouksen Ilmapiiri",
      reactions: "Käytetyt Reaktiot",
      positive: "Positiivinen",
      neutral: "Neutraali",
      negative: "Negatiivinen",
      perParticipant: "Tunnelma Osallistujittain",
      keywords: "Avainsanat"
    },
    footer: {
      generatedBy: "Tämä raportti luotiin automaattisesti CSC Voice AI:n avulla",
      copyright: "© CSC Bilisim"
    }
  },
  'fr-FR': {
    title: "Rapport de Réunion",
    summary: "Résumé de la Réunion",
    generatedAt: "Généré le",
    stats: {
      totalParticipants: "Participants au Total",
      totalMessages: "Messages au Total",
      totalWords: "Mots au Total",
      duration: "Durée de la Réunion",
      minutes: "minutes"
    },
    participants: {
      title: "Détails des Participants",
      columns: {
        name: "Participant",
        messageCount: "Nombre de Messages",
        wordCount: "Nombre de Mots",
        participation: "Taux de Participation"
      }
    },
    mood: {
      title: "Ambiance de la Réunion",
      overall: "Humeur Générale",
      ambiance: "Ambiance de la Réunion",
      reactions: "Réactions Utilisées",
      positive: "Positif",
      neutral: "Neutre",
      negative: "Négatif",
      perParticipant: "Humeur par Participant",
      keywords: "Expressions Clés"
    },
    footer: {
      generatedBy: "Ce rapport a été généré automatiquement par CSC Voice AI",
      copyright: "© CSC Bilisim"
    }
  },
  'he-IL': {
    title: "דו\"ח פגישה",
    summary: "סיכום פגישה",
    generatedAt: "נוצר ב",
    stats: {
      totalParticipants: "סה\"כ משתתפים",
      totalMessages: "סה\"כ הודעות",
      totalWords: "סה\"כ מילים",
      duration: "משך הפגישה",
      minutes: "דקות"
    },
    participants: {
      title: "פרטי משתתפים",
      columns: {
        name: "משתתף",
        messageCount: "מספר הודעות",
        wordCount: "מספר מילים",
        participation: "אחוז השתתפות"
      }
    },
    mood: {
      title: "אווירת הפגישה",
      overall: "מצב כללי",
      ambiance: "אווירה כללית",
      reactions: "תגובות בשימוש",
      positive: "חיובי",
      neutral: "נייטרלי",
      negative: "שלילי",
      perParticipant: "מצב לפי משתתף",
      keywords: "מילות מפתח"
    },
    footer: {
      generatedBy: "הדוח נוצר אוטומטית על ידי CSC Voice AI",
      copyright: "© CSC Bilisim"
    }
  },
  'hu-HU': {
    title: "Találkozói Jelentés",
    summary: "Találkozó Összefoglaló",
    generatedAt: "Létrehozva",
    stats: {
      totalParticipants: "Összes Résztvevő",
      totalMessages: "Összes Üzenet",
      totalWords: "Összes Szó",
      duration: "Találkozó Időtartama",
      minutes: "perc"
    },
    participants: {
      title: "Résztvevők Adatai",
      columns: {
        name: "Résztvevő",
        messageCount: "Üzenetek Száma",
        wordCount: "Szavak Száma",
        participation: "Részvételi Arány"
      }
    },
    mood: {
      title: "Találkozó Hangulata",
      overall: "Általános Hangulat",
      ambiance: "Találkozói Atmoszféra",
      reactions: "Használt Reakciók",
      positive: "Pozitív",
      neutral: "Semleges",
      negative: "Negatív",
      perParticipant: "Hangulat Résztvevőnként",
      keywords: "Kulcsszavak"
    },
    footer: {
      generatedBy: "Ezt a jelentést automatikusan készítette a CSC Voice AI",
      copyright: "© CSC Bilisim"
    }
  },
  'it-IT': {
    title: "Rapporto Riunione",
    summary: "Sommario della Riunione",
    generatedAt: "Generato il",
    stats: {
      totalParticipants: "Totale Partecipanti",
      totalMessages: "Totale Messaggi",
      totalWords: "Totale Parole",
      duration: "Durata della Riunione",
      minutes: "minuti"
    },
    participants: {
      title: "Dettagli Partecipanti",
      columns: {
        name: "Partecipante",
        messageCount: "Conteggio Messaggi",
        wordCount: "Conteggio Parole",
        participation: "Tasso di Partecipazione"
      }
    },
    mood: {
      title: "Atmosfera della Riunione",
      overall: "Umore Generale",
      ambiance: "Atmosfera della Riunione",
      reactions: "Reazioni Utilizzate",
      positive: "Positivo",
      neutral: "Neutro",
      negative: "Negativo",
      perParticipant: "Umore per Partecipante",
      keywords: "Espressioni Chiave"
    },
    footer: {
      generatedBy: "Questo rapporto è stato generato automaticamente da CSC Voice AI",
      copyright: "© CSC Bilisim"
    }
  },
  'ja-JP': {
    title: "会議レポート",
    summary: "会議の概要",
    generatedAt: "生成日",
    stats: {
      totalParticipants: "総参加者数",
      totalMessages: "総メッセージ数",
      totalWords: "総単語数",
      duration: "会議の時間",
      minutes: "分"
    },
    participants: {
      title: "参加者の詳細",
      columns: {
        name: "参加者",
        messageCount: "メッセージ数",
        wordCount: "単語数",
        participation: "参加率"
      }
    },
    mood: {
      title: "会議の雰囲気",
      overall: "全体的なムード",
      ambiance: "会議の雰囲気",
      reactions: "使用されたリアクション",
      positive: "ポジティブ",
      neutral: "ニュートラル",
      negative: "ネガティブ",
      perParticipant: "参加者ごとのムード",
      keywords: "重要な表現"
    },
    footer: {
      generatedBy: "このレポートはCSC Voice AIによって自動生成されました",
      copyright: "© CSC Bilisim"
    }
  },
  'ko-KR': {
    title: "회의 보고서",
    summary: "회의 요약",
    generatedAt: "생성일",
    stats: {
      totalParticipants: "총 참여자 수",
      totalMessages: "총 메시지 수",
      totalWords: "총 단어 수",
      duration: "회의 시간",
      minutes: "분"
    },
    participants: {
      title: "참여자 세부정보",
      columns: {
        name: "참여자",
        messageCount: "메시지 수",
        wordCount: "단어 수",
        participation: "참여율"
      }
    },
    mood: {
      title: "회의 분위기",
      overall: "전체 분위기",
      ambiance: "회의 분위기",
      reactions: "사용된 반응",
      positive: "긍정적",
      neutral: "중립적",
      negative: "부정적",
      perParticipant: "참여자별 분위기",
      keywords: "핵심 표현"
    },
    footer: {
      generatedBy: "이 보고서는 CSC Voice AI에 의해 자동 생성되었습니다",
      copyright: "© CSC Bilisim"
    }
  },
  'ms-MY': {
  title: "Laporan Mesyuarat",
  summary: "Ringkasan Mesyuarat",
  generatedAt: "Dijana pada",
  stats: {
    totalParticipants: "Jumlah Peserta",
    totalMessages: "Jumlah Mesej",
    totalWords: "Jumlah Perkataan",
    duration: "Tempoh Mesyuarat",
    minutes: "minit"
  },
  participants: {
    title: "Maklumat Peserta",
    columns: {
      name: "Peserta",
      messageCount: "Bilangan Mesej",
      wordCount: "Bilangan Perkataan",
      participation: "Kadar Penyertaan"
    }
  },
  mood: {
    title: "Suasana Mesyuarat",
    overall: "Keadaan Keseluruhan",
    ambiance: "Suasana Mesyuarat",
    reactions: "Reaksi Digunakan",
    positive: "Positif",
    neutral: "Neutral",
    negative: "Negatif",
    perParticipant: "Keadaan Mengikut Peserta",
    keywords: "Ungkapan Penting"
  },
  footer: {
    generatedBy: "Laporan ini dijana secara automatik oleh CSC Voice AI",
    copyright: "© CSC Bilisim"
  }
},
'pl-PL': {
  title: "Raport Spotkania",
  summary: "Podsumowanie Spotkania",
  generatedAt: "Wygenerowano dnia",
  stats: {
    totalParticipants: "Łączna liczba uczestników",
    totalMessages: "Łączna liczba wiadomości",
    totalWords: "Łączna liczba słów",
    duration: "Czas trwania spotkania",
    minutes: "minut"
  },
  participants: {
    title: "Szczegóły Uczestników",
    columns: {
      name: "Uczestnik",
      messageCount: "Liczba wiadomości",
      wordCount: "Liczba słów",
      participation: "Poziom Uczestnictwa"
    }
  },
  mood: {
    title: "Atmosfera Spotkania",
    overall: "Ogólny Nastrój",
    ambiance: "Atmosfera Spotkania",
    reactions: "Używane reakcje",
    positive: "Pozytywne",
    neutral: "Neutralne",
    negative: "Negatywne",
    perParticipant: "Nastrój według uczestnika",
    keywords: "Kluczowe frazy"
  },
  footer: {
    generatedBy: "Ten raport został wygenerowany automatycznie przez CSC Voice AI",
    copyright: "© CSC Bilisim"
  }
},
'pt-PT': {
  title: "Relatório da Reunião",
  summary: "Resumo da Reunião",
  generatedAt: "Gerado em",
  stats: {
    totalParticipants: "Total de Participantes",
    totalMessages: "Total de Mensagens",
    totalWords: "Total de Palavras",
    duration: "Duração da Reunião",
    minutes: "minutos"
  },
  participants: {
    title: "Detalhes dos Participantes",
    columns: {
      name: "Participante",
      messageCount: "Número de Mensagens",
      wordCount: "Número de Palavras",
      participation: "Taxa de Participação"
    }
  },
  mood: {
    title: "Clima da Reunião",
    overall: "Estado Geral",
    ambiance: "Clima da Reunião",
    reactions: "Reações Usadas",
    positive: "Positivo",
    neutral: "Neutro",
    negative: "Negativo",
    perParticipant: "Clima por Participante",
    keywords: "Frases Relevantes"
  },
  footer: {
    generatedBy: "Este relatório foi gerado automaticamente pelo CSC Voice AI",
    copyright: "© CSC Bilisim"
  }
},
'ro-RO': {
  title: "Raportul Întâlnirii",
  summary: "Rezumatul Întâlnirii",
  generatedAt: "Generat la",
  stats: {
    totalParticipants: "Total Participanți",
    totalMessages: "Total Mesaje",
    totalWords: "Total Cuvinte",
    duration: "Durata Întâlnirii",
    minutes: "minute"
  },
  participants: {
    title: "Detalii Participanți",
    columns: {
      name: "Participant",
      messageCount: "Număr Mesaje",
      wordCount: "Număr Cuvinte",
      participation: "Procent Participare"
    }
  },
  mood: {
    title: "Atmosfera Întâlnirii",
    overall: "Starea Generală",
    ambiance: "Atmosfera Întâlnirii",
    reactions: "Reacții Utilizate",
    positive: "Pozitiv",
    neutral: "Neutru",
    negative: "Negativ",
    perParticipant: "Starea pe Participanți",
    keywords: "Expresii Cheie"
  },
  footer: {
    generatedBy: "Acest raport a fost generat automat de CSC Voice AI",
    copyright: "© CSC Bilisim"
  }
},
'ru-RU': {
  title: "Отчет о встрече",
  summary: "Сводка встречи",
  generatedAt: "Создано",
  stats: {
    totalParticipants: "Всего участников",
    totalMessages: "Всего сообщений",
    totalWords: "Всего слов",
    duration: "Длительность встречи",
    minutes: "минут"
  },
  participants: {
    title: "Детали участников",
    columns: {
      name: "Участник",
      messageCount: "Количество сообщений",
      wordCount: "Количество слов",
      participation: "Уровень участия"
    }
  },
  mood: {
    title: "Атмосфера встречи",
    overall: "Общее настроение",
    ambiance: "Атмосфера встречи",
    reactions: "Использованные реакции",
    positive: "Положительное",
    neutral: "Нейтральное",
    negative: "Отрицательное",
    perParticipant: "Настроение по участникам",
    keywords: "Ключевые фразы"
  },
  footer: {
    generatedBy: "Этот отчет был автоматически создан CSC Voice AI",
    copyright: "© CSC Bilisim"
  }
},
  'sv-SE': {
    title: "Mötesrapport",
    summary: "Mötessammanfattning",
    generatedAt: "Genererat den",
    stats: {
      totalParticipants: "Totalt antal deltagare",
      totalMessages: "Totalt antal meddelanden",
      totalWords: "Totalt antal ord",
      duration: "Mötets längd",
      minutes: "minuter"
    },
    participants: {
      title: "Deltagardetaljer",
      columns: {
        name: "Deltagare",
        messageCount: "Antal meddelanden",
        wordCount: "Antal ord",
        participation: "Deltagandenivå"
      }
    },
    mood: {
      title: "Mötesatmosfär",
      overall: "Övergripande stämning",
      ambiance: "Mötesatmosfär",
      reactions: "Använda reaktioner",
      positive: "Positiv",
      neutral: "Neutral",
      negative: "Negativ",
      perParticipant: "Stämning per deltagare",
      keywords: "Viktiga fraser"
    },
    footer: {
      generatedBy: "Den här rapporten genererades automatiskt av CSC Voice AI",
      copyright: "© CSC Bilisim"
    }
  },
  'th-TH': {
    title: "รายงานการประชุม",
    summary: "สรุปการประชุม",
    generatedAt: "สร้างเมื่อ",
    stats: {
      totalParticipants: "จำนวนผู้เข้าร่วมทั้งหมด",
      totalMessages: "จำนวนข้อความทั้งหมด",
      totalWords: "จำนวนคำทั้งหมด",
      duration: "ระยะเวลาการประชุม",
      minutes: "นาที"
    },
    participants: {
      title: "รายละเอียดผู้เข้าร่วม",
      columns: {
        name: "ผู้เข้าร่วม",
        messageCount: "จำนวนข้อความ",
        wordCount: "จำนวนคำ",
        participation: "ระดับการมีส่วนร่วม"
      }
    },
    mood: {
      title: "บรรยากาศการประชุม",
      overall: "ภาพรวมอารมณ์",
      ambiance: "บรรยากาศการประชุม",
      reactions: "ปฏิกิริยาที่ใช้",
      positive: "เชิงบวก",
      neutral: "เป็นกลาง",
      negative: "เชิงลบ",
      perParticipant: "อารมณ์ตามผู้เข้าร่วม",
      keywords: "คำสำคัญ"
    },
    footer: {
      generatedBy: "รายงานนี้สร้างขึ้นโดยอัตโนมัติโดย CSC Voice AI",
      copyright: "© CSC Bilisim"
    }
  },
  'tr-TR': {
    title: "Toplantı Raporu",
    summary: "Toplantı Özeti",
    generatedAt: "Oluşturulma Tarihi",
    stats: {
      totalParticipants: "Toplam Katılımcı",
      totalMessages: "Toplam Mesaj",
      totalWords: "Toplam Kelime",
      duration: "Toplantı Süresi",
      minutes: "dakika"
    },
    participants: {
      title: "Katılımcı Detayları",
      columns: {
        name: "Katılımcı",
        messageCount: "Mesaj Sayısı",
        wordCount: "Kelime Sayısı",
        participation: "Katılım Oranı"
      }
    },
    mood: {
      title: "Toplantı Atmosferi",
      overall: "Genel Durum",
      ambiance: "Toplantı Atmosferi",
      reactions: "Kullanılan Tepkiler",
      positive: "Pozitif",
      neutral: "Nötr",
      negative: "Negatif",
      perParticipant: "Katılımcıya Göre Durum",
      keywords: "Anahtar İfadeler"
    },
    footer: {
      generatedBy: "Bu rapor CSC Voice AI tarafından otomatik olarak oluşturulmuştur",
      copyright: "© CSC Bilisim"
    }
  },
  'uk-UA': {
    title: "Звіт про зустріч",
    summary: "Резюме зустрічі",
    generatedAt: "Згенеровано",
    stats: {
      totalParticipants: "Загальна кількість учасників",
      totalMessages: "Загальна кількість повідомлень",
      totalWords: "Загальна кількість слів",
      duration: "Тривалість зустрічі",
      minutes: "хвилин"
    },
    participants: {
      title: "Деталі учасників",
      columns: {
        name: "Учасник",
        messageCount: "Кількість повідомлень",
        wordCount: "Кількість слів",
        participation: "Рівень участі"
      }
    },
    mood: {
      title: "Атмосфера зустрічі",
      overall: "Загальний настрій",
      ambiance: "Атмосфера зустрічі",
      reactions: "Використані реакції",
      positive: "Позитивний",
      neutral: "Нейтральний",
      negative: "Негативний",
      perParticipant: "Настрій за учасниками",
      keywords: "Ключові фрази"
    },
    footer: {
      generatedBy: "Цей звіт був автоматично згенерований за допомогою CSC Voice AI",
      copyright: "© CSC Bilisim"
    }
  },
  'vi-VN': {
    title: "Báo Cáo Cuộc Họp",
    summary: "Tóm Tắt Cuộc Họp",
    generatedAt: "Tạo vào",
    stats: {
      totalParticipants: "Tổng số người tham dự",
      totalMessages: "Tổng số tin nhắn",
      totalWords: "Tổng số từ",
      duration: "Thời lượng cuộc họp",
      minutes: "phút"
    },
    participants: {
      title: "Chi Tiết Người Tham Dự",
      columns: {
        name: "Người tham dự",
        messageCount: "Số lượng tin nhắn",
        wordCount: "Số lượng từ",
        participation: "Tỷ lệ tham gia"
      }
    },
    mood: {
      title: "Không Khí Cuộc Họp",
      overall: "Tình Hình Chung",
      ambiance: "Không Khí Cuộc Họp",
      reactions: "Phản ứng đã sử dụng",
      positive: "Tích cực",
      neutral: "Trung lập",
      negative: "Tiêu cực",
      perParticipant: "Tình hình theo từng người tham dự",
      keywords: "Cụm từ nổi bật"
    },
    footer: {
      generatedBy: "Báo cáo này được tạo tự động bởi CSC Voice AI",
      copyright: "© CSC Bilisim"
    }
  },
  'zh-CN': {
    title: "会议报告",
    summary: "会议摘要",
    generatedAt: "生成于",
    stats: {
      totalParticipants: "总参与者",
      totalMessages: "总消息数",
      totalWords: "总字数",
      duration: "会议时长",
      minutes: "分钟"
    },
    participants: {
      title: "参与者详情",
      columns: {
        name: "参与者",
        messageCount: "消息数量",
        wordCount: "单词数量",
        participation: "参与度"
      }
    },
    mood: {
      title: "会议氛围",
      overall: "整体情绪",
      ambiance: "会议氛围",
      reactions: "使用的反应",
      positive: "积极",
      neutral: "中立",
      negative: "消极",
      perParticipant: "每个参与者的情绪",
      keywords: "重点词语"
    },
    footer: {
      generatedBy: "此报告由 CSC Voice AI 自动生成",
      copyright: "© CSC Bilisim"
    }
  }
};

const WebVoiceTranslator = () => {
  // Kullanıcı Context'i
  const { currentMeetingId, currentUserId } = useContext(MeetingContext);
  const { user } = useContext(UserContext);
  const { currentMeeting } = useContext(MeetingContext);

  // State tanımlamaları
  const [isListening, setIsListening] = useState(false);
  const [error, setError] = useState('');
  const [micPermission, setMicPermission] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState('tr-TR');
  const [userName, setUserName] = useState(DEFAULT_USER_NAME);
  const [displayedMessages, setDisplayedMessages] = useState([]);
  const [lastFetchedMessageId, setLastFetchedMessageId] = useState(0);
  const [speechServiceReady, setSpeechServiceReady] = useState(false);
  const [isInitializing, setIsInitializing] = useState(true);
  const [theme, setTheme] = useState('default');
  const [meetingId, setMeetingId] = useState(null);
  const [sessionId, setSessionId] = useState(null);
  const [reportModalOpen, setReportModalOpen] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [reportReason, setReportReason] = useState('');
  const [reportDescription, setReportDescription] = useState('');
  const [teamsUserId, setTeamsUserId] = useState(null);
  const [buttonsDisabled, setButtonsDisabled] = useState(false);
  const [selectedIndustry, setSelectedIndustry] = useState('technology'); // Yeni: Seçili sektör
  const [selectedDepartment, setSelectedDepartment] = useState('executive'); // Yeni: Seçili departman
  const [meetingSubject, setMeetingSubject] = useState('');

  
  

  // Ref tanımlamaları
  const recognizers = useRef({});
  const messageQueueRef = useRef([]);
  const displayTimeoutRef = useRef(null);
  const messagePollingInterval = useRef(null);
  
  // Teams entegrasyonu için yardımcı fonksiyon
  const getTeamsContext = useCallback(async () => {
    try {
      await microsoftTeams.app.initialize();
      const teamsContext = await microsoftTeams.app.getContext();
      console.log('Teams context:', teamsContext);
      return teamsContext;
    } catch (error) {
      console.log('Not in Teams or Teams context not available:', error);
      return null;
    }
  }, []);
  
  // Log kaydetme fonksiyonu
  const logError = async (error, context = {}) => {
    try {
      await fetch(`${API_BASE_URL}/api/logs`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          'Accept': 'application/json; charset=UTF-8',
          'Accept-Charset': 'UTF-8'
        },
        body: JSON.stringify({
          endpoint: window.location.pathname,
          method: context?.method || 'POST',
          error: error.message,
          context: JSON.stringify(context)
        })
      });
    } catch (logError) {
      console.error('Log kaydedilemedi:', logError);
    }
  };

  console.warn('Geçerli kullanıcı ID bilgisi:', currentUserId );


  const handleIndustryChange = async (e) => {
    const newIndustry = e.target.value;
    setSelectedIndustry(newIndustry);
    
    try {
      // Toplantı/oturum ID'si kontrolü yap
      const currentMeetingId = meetingId || sessionId;
      const currentUserId = teamsUserId || user?.id || 'guest';
      
      if (currentMeetingId && currentUserId) {
        await apiCall('/api/user-preferences', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            meetingId: currentMeetingId,
            userId: currentUserId,
            industry: newIndustry  // Bu parametrenin adını değiştirmedim
          })
        });
        
        console.log('Sektör tercihi güncellendi:', newIndustry);
      }
    } catch (error) {
      console.error('Sektör değiştirme hatası:', error);
      setError('Sektör tercihi kaydedilemedi: ' + error.message);
    }
  };
  
  const handleDepartmentChange = async (e) => {
    const newDepartment = e.target.value;
    setSelectedDepartment(newDepartment);
    
    try {
      // Toplantı/oturum ID'si kontrolü yap
      const currentMeetingId = meetingId || sessionId;
      const currentUserId = teamsUserId || user?.id || 'guest';
      
      if (currentMeetingId && currentUserId) {
        await apiCall('/api/user-preferences', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            meetingId: currentMeetingId,
            userId: currentUserId,
            department: newDepartment  // Bu parametrenin adını değiştirmedim
          })
        });
        
        console.log('Departman tercihi güncellendi:', newDepartment);
      }
    } catch (error) {
      console.error('Departman değiştirme hatası:', error);
      setError('Departman tercihi kaydedilemedi: ' + error.message);
    }
  };

  // initializeApp useEffect içine veya ayrı bir useEffect olarak ekleyin
useEffect(() => {
  const checkSubscription = async () => {
    try {
      // Toplantı/kullanıcı bilgilerini al
      const currentMeetingId = meetingId || sessionId;
      const currentUserId = teamsUserId || user?.id || 'guest';

      if (!currentMeetingId || !currentUserId) {
        console.log('Abonelik kontrolü için toplantı veya kullanıcı bilgisi eksik');
        return;
      }

      // Teams context'ini almaya çalış
      let tenantId = null;
      try {
        const teamsContext = await getTeamsContext();
        tenantId = teamsContext?.user?.tenant?.id;
      } catch (e) {
        console.warn('Teams tenant ID alınamadı:', e);
      }

      // Tenant ID bulunamazsa kullanıcı ID'sini kullan
      if (!tenantId) {
        tenantId = currentUserId;
      }

      console.log('Abonelik kontrolü yapılıyor:', {
        subscriptionId: currentUserId,
        tenantId: tenantId,
        meetingId: currentMeetingId
      });

      // Abonelik kontrolü API çağrısı
      const subscriptionCheck = await fetch(`${API_BASE_URL}/api/subscriptionCheck`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          subscriptionId: currentUserId,
          tenantId: tenantId,
          meetingId: currentMeetingId
        })
      });

      const result = await subscriptionCheck.json();
      console.log('Abonelik kontrolü yanıtı:', result);

      if (!result.success) {
        setButtonsDisabled(true);
        setError(result.error || 'Abonelik kontrolü başarısız oldu');
        return;
      }

      if (!result.canUseMeeting) {
        setButtonsDisabled(true);
        setError(
          `Paket sınırına ulaşıldı. ${result.subscription.packageName} paketiniz 
          ${result.subscription.meetingLimit} toplantı hakkına sahip. 
          Şimdiye kadar ${result.subscription.meetingsUsed} toplantı kullanıldı. 
          Lütfen www.cscvoice.ai adresinden paketinizi yükseltin.`
        );
        return;
      }

      // Kontrol başarılıysa butonları aktif et
      setButtonsDisabled(false);
      setError('');

    } catch (error) {
      console.error('Abonelik kontrolü hatası:', error);
      logError(error, { context: 'subscriptionCheck' });
      // Hata oluşsa bile kullanıcının kullanmasına izin ver
      setButtonsDisabled(false);
    }
  };

  // Eğer toplantı/oturum ID'si veya kullanıcı ID'si değişirse abonelik kontrolü yap
  if (meetingId || sessionId) {
    checkSubscription();
  }
}, [meetingId, sessionId, teamsUserId, user, getTeamsContext]);

// Modal kapatma fonksiyonu
  const handleModalClose = () => {
    setReportModalOpen(false);
    setSelectedMessage(null);
    setReportReason('');
    setReportDescription('');
    setError(''); // Hata mesajını da temizle
  };


  useEffect(() => {
    // URL'den parametreleri al
    const params = new URLSearchParams(window.location.search);
    const urlMeetingCode = params.get('meetingCode');
    const urlUserId = params.get('userId');
    const urlUserName = params.get('userName');
    const urlMeetingSubject = params.get('meetingSubject'); // Yeni eklenen satır
    
    console.log('URL parametreleri:', {
      meetingCode: urlMeetingCode,
      userId: urlUserId,
      userName: urlUserName,
      meetingSubject: urlMeetingSubject // Yeni eklenen satır
    });

      // Toplantı konusunu state'e kaydet - burada setMeetingSubject kullanılmalı
      if (urlMeetingSubject) {
        console.log('URL\'den gelen toplantı konusu kabul edildi:', urlMeetingSubject);
        setMeetingSubject(decodeURIComponent(urlMeetingSubject)); // decodeURIComponent ekledim
      }
    
    // Eğer URL'de meetingCode varsa, kendi oluşturduğumuz yerine onu kullan
    if (urlMeetingCode) {
      console.log('URL\'den gelen meeting code kabul edildi:', urlMeetingCode);
      
      // MeetingId ve SessionId olarak doğrudan encoded değeri kullan
      setMeetingId(urlMeetingCode);
      setSessionId(urlMeetingCode);
      
      // API'ye toplantıyı kaydet/güncelle
      if (urlUserId) {
        setTimeout(() => {
          try {
            fetch(`${API_BASE_URL}/api/meetings`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Accept': 'application/json; charset=UTF-8'
              },
              body: JSON.stringify({
                meetingId: urlMeetingCode, // Encoded değeri doğrudan kullan
                userId: urlUserId,
                userName: urlUserName || 'Misafir Kullanıcı',
                status: 'active',
                platformType: 'teams-electron'
                // MeetingUrl bilgisine gerek yok, çünkü encoded ID içinde
              })
            });
          } catch (error) {
            console.warn('Toplantı kayıt hatası:', error);
          }
        }, 100);
      }
    }
    
    // User ID ve isim bilgilerini de al
    if (urlUserId) {
      console.log('URL\'den gelen user ID kabul edildi:', urlUserId);
      setTeamsUserId(urlUserId);
    }
    
    if (urlUserName) {
      console.log('URL\'den gelen user name kabul edildi:', urlUserName);
      setUserName(urlUserName);
    }
  }, [setUserName, setMeetingSubject]);


  // API çağrı yardımcı fonksiyonua
  const apiCall = useCallback(async (endpoint, options = {}) => {
    try {
      console.log(`API çağrısı: ${endpoint}`, options);

      const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        ...options,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          'Accept': 'application/json; charset=UTF-8',
          'Accept-Charset': 'UTF-8',
          ...options.headers
        }
      });

      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.error || `HTTP hatası! durum: ${response.status}`);
      }

      if (data.error) {
        throw new Error(data.error);
      }

      console.log(`API yanıtı alındı: ${endpoint}`, data);
      return data;
    } catch (error) {
      console.error(`API Hatası (${endpoint}):`, error);
      logError(error, { endpoint, options });
      throw error;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (currentMeeting?.id) {
      console.log('MeetingContext\'ten toplantı ID\'si alındı:', currentMeeting.id);
      
      // State güncellemelerini toplu yap
      setMeetingId(currentMeeting.id);
      setSessionId(currentMeeting.id);
      
      // Eğer toplantı URL'si varsa localStorage'a kaydet (hata durumunda kullanım için)
      if (currentMeeting.meetingUrl) {
        try {
          localStorage.setItem('lastMeetingUrl', currentMeeting.meetingUrl);
          localStorage.setItem('lastMeetingId', currentMeeting.id);
        } catch (e) {
          console.warn('localStorage kayıt hatası:', e);
        }
      }
      
      // Toplantı başladığını API'ye bildir, ancak ana thread'i bloklamasını önle
      setTimeout(() => {
        try {
          fetch(`${API_BASE_URL}/api/meetings`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json; charset=UTF-8',
              'Accept': 'application/json; charset=UTF-8'
            },
            body: JSON.stringify({
              meetingId: currentMeeting.id,
              userId: teamsUserId || user?.id || 'guest',
              userName: user?.displayName || userName,
              status: 'active',
              platformType: teamsUserId ? 'teams' : 'web',
              meetingDetails: {
                subject: currentMeeting.subject,
                meetingUrl: currentMeeting.meetingUrl
              }
            })
          });
        } catch (error) {
          console.warn('API request for meeting sync failed:', error);
        }
      }, 100);
    }
  }, [currentMeeting, teamsUserId, user, userName]);

  useEffect(() => {
    // Eğer sessionId değişirse ama meetingId yoksa, sessionId'yi meetingId'ye de ata
    if (sessionId && !meetingId) {
      setMeetingId(sessionId);
    }
    
    // Eğer meetingId değişirse ama sessionId yoksa, meetingId'yi sessionId'ye de ata
    if (meetingId && !sessionId) {
      setSessionId(meetingId);
    }
    
    // Toplantı ID'si değiştiğinde, API'ye kullanıcı dilini bildir
    const currentMeetingId = meetingId || sessionId;
    const currentUserId = teamsUserId || user?.id || 'guest';
    
    if (currentMeetingId && selectedLanguage) {
      fetch(`${API_BASE_URL}/api/user-preferences`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          'Accept': 'application/json; charset=UTF-8'
        },
        body: JSON.stringify({
          meetingId: currentMeetingId,
          userId: currentUserId,
          preferred_language_id: selectedLanguage
        })
      }).catch(error => {
        console.warn('Dil tercihi API hatası:', error);
      });
    }
  }, [meetingId, sessionId, selectedLanguage, teamsUserId, user]);

  useEffect(() => {
    // Eğer henüz bir meeting ID yoksa localStorage'dan çek
    if (!meetingId && !sessionId && !currentMeeting?.id) {
      try {
        const savedMeetingId = localStorage.getItem('lastMeetingId');
        if (savedMeetingId) {
          console.log('Son toplantı ID localStorage\'dan yüklendi:', savedMeetingId);
          setMeetingId(savedMeetingId);
          setSessionId(savedMeetingId);
        }
      } catch (e) {
        console.warn('localStorage okuma hatası:', e);
      }
    }
  }, [currentMeeting, meetingId, sessionId]);

  // Çeviri fonksiyonu
  const translateText = useCallback(async (text, fromLang, toLang) => {
    if (!text?.trim()) return '';
    try {
      console.log('Çeviri başlatılıyor:', { text, fromLang, toLang });
      const response = await fetch(
        `https://${TRANSLATOR_REGION}.api.cognitive.microsoft.com/translator/text/v3.0/translate?api-version=3.0&from=${fromLang}&to=${toLang}`,
        {
          method: 'POST',
          headers: {
            'Ocp-Apim-Subscription-Key': TRANSLATOR_KEY,
            'Content-Type': 'application/json',
            'Ocp-Apim-Subscription-Region': TRANSLATOR_REGION
          },
          body: JSON.stringify([{ Text: text }])
        }
      );

      const data = await response.json();
      console.log('Çeviri tamamlandı:', data);
      return data[0]?.translations[0]?.text || 'Çeviri başarısız';
    } catch (error) {
      console.warn('Çeviri hatası:', error);
      logError(error, { text, fromLang, toLang });
      return 'Çeviri başarısız';
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Teams initialize
  useEffect(() => {
    const initTeams = async () => {
      try {
        const teamsContext = await getTeamsContext();
        
        if (teamsContext) {
          // Set meeting ID from Teams
          if (teamsContext.meeting?.id) {
            const teamsMeetingId = teamsContext.meeting.id;
            console.log('Using Teams meeting ID:', teamsMeetingId);
            setMeetingId(teamsMeetingId);
            setSessionId(teamsMeetingId);
          }
          
          // Set user info from Teams
          if (teamsContext.user) {
            if (teamsContext.user.displayName) {
              setUserName(teamsContext.user.displayName);
            }
            
            if (teamsContext.user.id) {
              console.log('Using Teams user ID:', teamsContext.user.id);
              setTeamsUserId(teamsContext.user.id);
            }
          }
        }
      } catch (error) {
        console.error('Microsoft Teams initialization error:', error);
        logError(error, { context: 'teamsInitialization' });
      }
    };
    
    initTeams();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Tema renkleri
  const themeColors = {
    default: {
      background: '#f8f9fa',
      cardBg: '#ffffff',
      text: '#333333',
      border: '#dee2e6',
      navBg: '#ffffff',
      primary: '#6264A7',
      messageHeader: '#6264A7',
      muted: '#6c757d',
      shadow: 'rgba(0, 0, 0, 0.1)',
      modalBg: '#ffffff'
    },
    dark: {
      background: '#201F1F',
      cardBg: '#2D2C2C',
      text: '#ffffff',
      border: '#484644',
      navBg: '#2D2C2C',
      primary: '#6264A7',
      messageHeader: 'rgba(98, 100, 167, 0.2)',
      muted: '#E0E0E0',
      shadow: 'rgba(0, 0, 0, 0.25)',
      modalBg: '#2D2C2C'
    }
  };

  // Speech service kontrolü
  const checkSpeechService = useCallback(async () => {
    try {
      console.log('Speech servis kontrolü başlatılıyor...');
      const speechConfig = sdk.SpeechConfig.fromSubscription(SPEECH_KEY, SPEECH_REGION);
      if (speechConfig) {
        console.log('Speech servis hazır');
        setSpeechServiceReady(true);
        return true;
      }
      return false;
    } catch (err) {
      console.error('Speech servis hatası:', err);
      logError(err, { context: 'checkSpeechService' });
      setSpeechServiceReady(false);
      return false;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // Toplantı/Oturum başlatma
  const startMeeting = useCallback(async () => {
    try {
      // Önce mevcut bir toplantı veya oturum ID'si var mı kontrol et
      let meetingIdToUse = currentMeeting?.id || meetingId || sessionId;
      
      // Yoksa yeni bir ID oluştur
      if (!meetingIdToUse) {
        meetingIdToUse = `web-meeting-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
        console.log('Yeni toplantı ID oluşturuldu:', meetingIdToUse);
      }
      
      console.log('Toplantı başlatılıyor:', meetingIdToUse);
      
      const response = await apiCall('/api/meetings', {
        method: 'POST',
        body: JSON.stringify({
          meetingId: meetingIdToUse,
          userId: teamsUserId || user?.id || 'guest',
          userName: user?.displayName || userName || 'Misafir Kullanıcı',
          status: 'active',
          platformType: teamsUserId ? 'teams' : 'web',
          meetingDetails: {
            subject: currentMeeting?.subject || 'CSC Voice AI - Meeting Report',
            meetingUrl: currentMeeting?.meetingUrl || window.location.href
          }
        })
      });
  
      if (response.success) {
        console.log('Toplantı başarıyla başlatıldı:', response);
        
        // State'leri güncelle
        setMeetingId(meetingIdToUse);
        setSessionId(meetingIdToUse);
        
        return meetingIdToUse;
      } else {
        throw new Error('API yanıtında başarı bilgisi yok');
      }
    } catch (error) {
      console.error('Meeting startup error:', error);
      logError(error, { context: 'startMeeting' });
      setError('Meeting could not be started: ' + (error.message || 'Unknown error'));
      return null;
    }
  }, [
    currentMeeting, 
    meetingId, 
    sessionId, 
    teamsUserId, 
    user, 
    userName, 
    apiCall
  ]);

  console.error('Initialization error:', currentMeetingId);

  // Dil değişikliği handler'ı
  const handleLanguageChange = async (e) => {
    if (isListening) return;
    
    const newLanguage = e.target.value;
    console.log('Dil değiştiriliyor:', { newLanguage, meetingId, sessionId });
  
    try {
      // Oturum/toplantı yoksa önce yeni bir oturum oluştur
      if (!meetingId && !sessionId) {
        const newSessionId = `web-meeting-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
        setSessionId(newSessionId);
        console.log('Dil değişimi için yeni oturum oluşturuldu:', newSessionId);
        
        // API'ye yeni oturumu bildir (gecikmeli)
        setTimeout(() => {
          try {
            apiCall('/api/meetings', {
              method: 'POST',
              body: JSON.stringify({
                meetingId: newSessionId,
                userId: teamsUserId || user?.id || 'guest',
                userName: user?.displayName || userName,
                status: 'active',
                platformType: 'web',
                meetingDetails: {
                  subject: 'Web Translation Session',
                  meetingUrl: window.location.href
                }
              })
            });
          } catch (e) {
            console.warn('Meeting creation during language change failed:', e);
          }
        }, 100);
      }
      
      // Geçerli bir toplantı ID'si var mı kontrol et (yeni oluşturulmuş olabilir)
      const currentMeetingId = meetingId || sessionId;
      const currentUserId = teamsUserId || user?.id || 'guest';
      
      if (currentMeetingId) {
        // Önce dili ayarla
        setSelectedLanguage(newLanguage);
        
        // API'ye dil tercihini gönder
        try {
          const response = await fetch(`${API_BASE_URL}/api/user-preferences`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json; charset=UTF-8',
              'Accept': 'application/json; charset=UTF-8'
            },
            body: JSON.stringify({
              meetingId: currentMeetingId,
              userId: currentUserId,
              language: newLanguage // API'nin beklediği parametre adı
            })
          });
          
          const data = await response.json();
          
          if (!response.ok) {
            console.warn('Dil tercihi kaydedilirken API hatası:', data);
          } else {
            console.log('Dil tercihi yanıtı:', data);
          }
        } catch (parseError) {
          console.warn('Dil tercihi yanıt ayrıştırma hatası:', parseError);
        }
        
        // Mevcut mesajları temizle ve yenilerini getir
        setLastFetchedMessageId(0);
        setDisplayedMessages([]);
        messageQueueRef.current = [];
        
        // Hemen yeni mesajları getirmeyi dene
        try {
          await fetchNewMessages();
        } catch (fetchError) {
          console.warn('Yeni mesajları getirme hatası:', fetchError);
        }
        
        // Değişiklikten sonra 1 saniye bekleyip tekrar mesajları getir
        // Bazen backend'in değişikliği işlemesi biraz zaman alabilir
        setTimeout(async () => {
          try {
            await fetchNewMessages();
          } catch (delayedFetchError) {
            console.warn('Gecikmiş mesaj getirme hatası:', delayedFetchError);
          }
        }, 1000);
    
        console.log('Dil tercihi güncellendi:', newLanguage);
      } else {
        // Toplantı ID'si yoksa sadece yerel değişiklik yap
        console.warn('Dil değişimi için aktif toplantı bulunamadı');
        setSelectedLanguage(newLanguage);
      }
    } catch (error) {
      // Hata olsa bile dili değiştir
      setSelectedLanguage(newLanguage);
      
      console.error('Dil değişikliği hatası:', error);
      logError(error, { context: 'handleLanguageChange', newLanguage });
      setError('Dil tercihi kaydedilemedi: ' + (error.message || 'Bilinmeyen hata'));
    }
  };

  // Mikrofon izni kontrolü
  const checkMicrophonePermission = useCallback(async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      stream.getTracks().forEach(track => track.stop());
      setMicPermission(true);
      setError('');
      return true;
    } catch (error) {
      console.error('Mikrofon erişim hatası:', error);
      logError(error, { context: 'checkMicrophonePermission' });
      setMicPermission(false);
      setError('Mikrofon izni reddedildi: ' + error.message);
      return false;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initializeTeamsContext = useCallback(async () => {
    try {
      await microsoftTeams.app.initialize();
      const context = await microsoftTeams.app.getContext();
      
      console.log('Teams Context:', JSON.stringify(context, null, 2));
      
      // Meeting ID kontrolü
      if (context?.meeting?.id) {
        console.log('Teams meeting ID:', context.meeting.id);
        setMeetingId(context.meeting.id);
        setSessionId(context.meeting.id);
        
        // Toplantı başlatma API'sini çağır
        await startMeeting();
      } else {
        console.warn('Teams context\'inde meeting ID bulunamadı');
      }
      
      // User bilgilerini alma
      if (context?.user) {
        console.log('Teams user:', JSON.stringify(context.user));
        if (context.user.displayName) {
          setUserName(context.user.displayName);
        }
        if (context.user.id) {
          setTeamsUserId(context.user.id);
        }
      }
    } catch (error) {
      console.error('Teams initialization error:', error);
      logError(error, { context: 'teamsInitialization' });
    }
  }, [startMeeting, setUserName]);
  
  // useEffect içinde çağırın
  useEffect(() => {
    initializeTeamsContext();
  }, [initializeTeamsContext]);

  useEffect(() => {
    const initialize = async () => {
      setIsInitializing(true);
      try {
        await initializeTeamsContext().catch(error => {
          console.warn('Teams context initialization warning:', error);
          // Bu hatayı kritik olarak değerlendirme
        });
        
        const isSpeechReady = await checkSpeechService();
        if (!isSpeechReady) {
          throw new Error('Speech service could not be initialized');
        }
        
        const hasMicPermission = await checkMicrophonePermission();
        if (!hasMicPermission) {
          throw new Error('Microphone permission could not be obtained');
        }
        
        // Burada elle bir oturum ID'si oluştur (tam tarih ve rastgele sayı ile)
        if (!meetingId && !sessionId) {
          const sessionIdToUse = `web-meeting-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
          setSessionId(sessionIdToUse);
          console.log('New session ID created:', sessionIdToUse);
        }
        
        setIsInitializing(false);
        
      } catch (err) {
        console.error('Initialization error:', err?.message || JSON.stringify(err));
        if (err?.message) {
          setError(`Initialization error: ${err.message}`);
        } else {
          // Undefined hatalarını gösterme
          console.warn('Undefined initialization error suppressed');
        }
        setIsInitializing(false);
        
      }
    };
    
    initialize();
  }, [initializeTeamsContext, checkSpeechService, checkMicrophonePermission, meetingId, sessionId]);

  // Yeni mesajları getirme
  const fetchNewMessages = useCallback(async () => {
    // Toplantı/oturum ID'si kontrolü yap
    const currentMeetingId = meetingId || sessionId;
    const currentUserId = teamsUserId || user?.id || 'guest';
    
    if (!currentMeetingId) {
      console.log('Aktif toplantı bulunamadı, mesajlar getirilemedi');
      return;
    }
    
    try {
      console.log('Mesajlar getiriliyor:', { 
        meetingId: currentMeetingId, 
        userId: currentUserId, 
        lastMessageId: lastFetchedMessageId,
        language: selectedLanguage // Dil bilgisini logla
      });
      
      // URL'ye dil parametresini ekleyin
      const url = `${API_BASE_URL}/api/messages?meetingId=${currentMeetingId}&userId=${currentUserId}&lastMessageId=${lastFetchedMessageId}&languageId=${selectedLanguage}`;
  
      console.log('Mesaj API URL:', url);
      
      const response = await fetch(url, {
        headers: {
          'Accept': 'application/json; charset=UTF-8'
        }
      });
      
      // Hata durumunda detaylı bilgi al
      if (!response.ok) {
        const errorText = await response.text();
        console.error(`HTTP error (${response.status}):`, errorText);
        throw new Error(`HTTP error ${response.status}: ${errorText}`);
      }
      
      // Yanıt boş mu kontrol et
      const text = await response.text();
      if (!text.trim()) {
        console.warn('Boş API yanıtı alındı');
        return;
      }
      
      try {
        const data = JSON.parse(text);
        console.log('Mesajlar getirildi:', data);
    
        if (data.success && data.messages?.length > 0) {
          console.log(`${data.messages.length} yeni mesaj bulundu!`);
          messageQueueRef.current.push(...data.messages);
          setLastFetchedMessageId(data.metadata.lastMessageId);
        }
      } catch (parseError) {
        console.error('JSON parse hatası:', parseError, 'Ham yanıt:', text);
      }
    } catch (error) {
      console.error('Mesaj getirme hatası:', error);
      logError(error, { context: 'fetchNewMessages', meetingId: currentMeetingId });
    }
  }, [meetingId, sessionId, teamsUserId, user, lastFetchedMessageId, selectedLanguage]); // selectedLanguage eklendi



  // Mesajları görüntüleme
  const displayNextMessage = useCallback(() => {
    if (messageQueueRef.current.length === 0) {
      fetchNewMessages();
      return;
    }
    
    const messages = messageQueueRef.current;
    messageQueueRef.current = [];

    setDisplayedMessages(prev => {
      const allMessages = [...prev];
      
      messages.forEach(message => {
        if (!allMessages.some(m => m.id === message.id)) {
          allMessages.push(message);
        }
      });

      return allMessages.sort((a, b) => 
        new Date(b.createdAt) - new Date(a.createdAt)
      );
    });

    displayTimeoutRef.current = setTimeout(() => {
      displayNextMessage();
    }, DISPLAY_DURATION);
  }, [fetchNewMessages]);

  
  const stopListening = useCallback(async () => {
    try {
      if (!isListening) return;
      
      const stopPromises = Object.values(recognizers.current).map(recognizer => {
        return new Promise((resolve) => {
          if (!recognizer) {
            resolve();
            return;
          }
          recognizer.stopContinuousRecognitionAsync(
            () => {
              console.log('Recognizer durduruldu');
              resolve();
            },
            (error) => {
              console.warn('Recognizer durdurma uyarısı:', error);
              logError(error, { context: 'stopListening' });
              resolve();
            }
          );
        });
      });
  
      await Promise.all(stopPromises);
      setIsListening(false);
      
      if (messagePollingInterval.current) {
        clearInterval(messagePollingInterval.current);
        messagePollingInterval.current = null;
      }
  
      console.log('Dinleme durduruldu');
      
    } catch (err) {
      console.error('Dinlemeyi durdurma hatası:', err);
      logError(err, { context: 'stopListening' });
      setIsListening(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isListening]);
  

  
  const startListening = useCallback(async () => {
    try {
      if (isListening) return;
  
      const meetingIdToUse = await startMeeting();
      if (!meetingIdToUse) {
        throw new Error('Toplantı başlatılamadı');
      }
  
      const hasMicPermission = await checkMicrophonePermission();
      if (!hasMicPermission) {
        throw new Error('Mikrofon izni alınamadı');
      }
  
      if (!speechServiceReady) {
        throw new Error('Speech servisi hazır değil');
      }
  
      await startMeeting();

      
      // Konuşma tanıma kurulumu
      const speechConfig = sdk.SpeechConfig.fromSubscription(SPEECH_KEY, SPEECH_REGION);
      speechConfig.speechRecognitionLanguage = selectedLanguage;

      speechConfig.setProperty("SpeechServiceConnection_EndSilenceTimeoutMs", "2000");  // Varsayılan değeri (500ms) artırın
      speechConfig.setProperty("SpeechServiceConnection_InitialSilenceTimeoutMs", "5000"); 
      speechConfig.setProperty("sdk.PropertyId.Speech_SegmentationSilenceTimeoutMs", "2000");
      speechConfig.setProperty("sdk.PropertyId.SpeechServiceResponse_PostProcessingOption", "TrueText");
      
      // Kullanıcı ID'sini speech config'e ekle
      const currentUserId = teamsUserId || user?.id || 'guest';
      speechConfig.setProperty("UserId", currentUserId);
      
      const audioConfig = sdk.AudioConfig.fromDefaultMicrophoneInput();
      const recognizer = new sdk.SpeechRecognizer(speechConfig, audioConfig);
      
      recognizers.current[selectedLanguage] = recognizer;
      
      // Tanıyıcı olayları ayarla
      recognizer.recognized = (s, e) => {
        if (e.result.reason === sdk.ResultReason.RecognizedSpeech) {
          const recognizedText = e.result.text.trim();
          if (recognizedText) {
            console.log(`Recognized text: ${recognizedText}`);
            
            // Geçerli toplantı ID'sini kontrol et
            const currentMeetingId = meetingId || sessionId || meetingIdToUse;
            const currentUserId = teamsUserId || user?.id || 'guest';
            
            if (!currentMeetingId) {
              console.error("Mesaj gönderilemedi: Toplantı ID'si bulunamadı");
              setError("Konuşma kaydedilemedi: Toplantı oturumu başlatılamadı.");
              return;
            }
            
            // API isteği için gerekli parametreleri hazırla
            const requestData = {
              meetingId: currentMeetingId,
              userId: currentUserId,
              userName: user?.displayName || userName,
              sourceText: recognizedText,  // API'nin beklediği parametreyi kullan
              sourceLanguageId: selectedLanguage,
              confidence: 0.9  // Varsayılan güven skoru
            };
            
            console.log('Mesaj isteği gönderiliyor:', requestData);
            
            // Speech record API'sini çağır
            fetch(`${API_BASE_URL}/api/speech-records`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Accept': 'application/json; charset=UTF-8'
              },
              body: JSON.stringify(requestData)
            })
            .then(response => {
              if (!response.ok) {
                return response.text().then(text => {
                  throw new Error(`HTTP error ${response.status}: ${text}`);
                });
              }
              return response.json();
            })
            .then(data => {
              console.log('Speech record yanıtı:', data);
              
              if (data.success) {
                // Şimdi çeviri isteklerini gönder
                const translationPromises = SUPPORTED_LANGUAGES.map(lang => {
                  // Kendi dilimize çeviri yapmaya gerek yok
                  if (lang.code === selectedLanguage) {
                    return Promise.resolve();
                  }
                  
                  // Translation API'sine istek gönder
                  return translateText(recognizedText, selectedLanguage.split('-')[0], lang.shortCode)
                    .then(translatedText => {
                      if (!translatedText) return null;
                      
                      return fetch(`${API_BASE_URL}/api/translations`, {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json; charset=UTF-8',
                          'Accept': 'application/json; charset=UTF-8'
                        },
                        body: JSON.stringify({
                          recordId: data.recordId,
                          languageId: lang.code,
                          translatedText: encodeURIComponent(translatedText),
                          meetingId: currentMeetingId
                        })
                      });
                    })
                    .catch(error => {
                      console.error(`Çeviri hatası (${lang.code}):`, error);
                      return null;
                    });
                });
                
                Promise.all(translationPromises)
                  .then(() => console.log('Tüm çeviriler tamamlandı'))
                  .catch(err => console.error('Çeviri işlemleri hatası:', err));
              }
            })
            .catch(error => {
              console.error('Speech record hatası:', error);
              setError('Konuşma kaydedilemedi: ' + error.message);
            });
          }
        }
      };
      
      // Sürekli tanıma başlat
      recognizer.startContinuousRecognitionAsync(
        () => {
          console.log('Recognition started');
          setIsListening(true);
        },
        (error) => {
          console.error('Recognition start error:', error);
          logError(error, { context: 'startRecognition' });
          setError('Recognition start error: ' + error);
          setIsListening(false);
        }
      );
      
    } catch (error) {
      console.error('Dinleme başlatma hatası:', error);
      logError(error, { context: 'startListening' });
      setError(error.message);
    }
  }, [checkMicrophonePermission, speechServiceReady, translateText, isListening, startMeeting, 
      selectedLanguage, teamsUserId, user, userName, meetingId, sessionId]);
  
  const handleReportClick = useCallback((message) => {
    setSelectedMessage(message);
    setReportModalOpen(true);
  }, []);


// Rapor oluşturma fonksiyonu - hata toleranslı versiyon
const generateSessionSummary = async () => {
  // UI için yükleme göstergesi
  const loadingIndicator = document.createElement('div');
  loadingIndicator.className = 'alert alert-info';
  loadingIndicator.innerHTML = `
    <div class="d-flex align-items-center">
      <div class="spinner-border spinner-border-sm me-2" role="status">
        <span class="visually-hidden">Yükleniyor...</span>
      </div>
      <span>Rapor oluşturuluyor. Bu işlem bir kaç dakika sürebilir, lütfen bekleyin...</span>
    </div>
  `;
  
  try {
    setError(''); // Önceki hataları temizle
    
    // Mesaj konteynırına yükleme göstergesini ekle
    const messagesContainer = document.querySelector('.messages-container');
    if (messagesContainer) {
      messagesContainer.prepend(loadingIndicator);
    }
    
    // Gerekli parametreleri belirle
    const currentMeetingId = meetingId || sessionId;
    if (!currentMeetingId) {
      throw new Error('Aktif toplantı bulunamadı');
    }
    
    // Kullanıcı bilgilerini hazırla
    const userLang = selectedLanguage || 'tr-TR';
    const translations = TRANSLATIONSREPORT[userLang] || TRANSLATIONSREPORT['tr-TR'];
    const currentUserId = teamsUserId || user?.id || 'guest';
    
    console.log('Rapor isteği yapılıyor:', {
      meetingId: currentMeetingId,
      language: userLang,
      industry: selectedIndustry,
      department: selectedDepartment
    });

    // Önce toplantı verilerini basit bir şekilde almayı deneyelim
    // API aşağıda tam raporu döndüremezse, basit bir rapor oluşturmak için veriler
    const simpleDataResponse = await fetch(`${API_BASE_URL}/api/messages?meetingId=${currentMeetingId}&userId=${currentUserId}&lastMessageId=0&getAll=true`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    // Basit verileri kontrol et
    let simpleData = { messages: [] };
    if (simpleDataResponse.ok) {
      try {
        const simpleFetchedData = await simpleDataResponse.text();
        if (simpleFetchedData && simpleFetchedData.trim() !== '') {
          simpleData = JSON.parse(simpleFetchedData);
        }
      } catch (simpleError) {
        console.warn('Simple data fetch error:', simpleError);
      }
    }

    // Tam rapor için API çağrısı
    let reportData = null;
    let apiError = null;
    
    try {
      // Fetch işlemi için zaman aşımı ekle
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 240000); // 240 saniye zaman aşımı
      
      // Sektör ve departman parametrelerini URL'ye ekle
      const url = `${API_BASE_URL}/api/MeetingReport?meetingId=${encodeURIComponent(currentMeetingId)}&language=${encodeURIComponent(userLang)}&industry=${encodeURIComponent(selectedIndustry)}&department=${encodeURIComponent(selectedDepartment)}`;
      
      // API çağrısı
      const response = await fetch(url, { 
        signal: controller.signal,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
      
      clearTimeout(timeoutId); // Zaman aşımını temizle
      
      // Ham yanıt durumunu logla
      console.log('API yanıt durumu:', response.status, response.statusText);
      
      // Yanıt durumunu kontrol et
      if (!response.ok) {
        throw new Error(`API hatası: ${response.status} ${response.statusText}`);
      }
      
      // Önce metin olarak yanıtı al ve incele
      const responseText = await response.text();
      console.log('API yanıt metni:', responseText.substring(0, 200) + '...');
      
      // Yanıtın boş olup olmadığını kontrol et
      if (!responseText || responseText.trim() === '') {
        throw new Error('API boş bir yanıt döndürdü');
      }
      
      // JSON'ı ayrıştırmayı dene
      try {
        reportData = JSON.parse(responseText);
        console.log('API verisi başarıyla ayrıştırıldı');
      } catch (jsonError) {
        console.error('JSON ayrıştırma hatası:', jsonError, 'yanıt:', responseText);
        throw new Error(`API'den geçersiz JSON yanıtı: ${jsonError.message}`);
      }

      // API başarı durumunu kontrol et
      if (!reportData.success) {
        throw new Error(reportData.error || 'API işlem hatası');
      }
    } catch (reportError) {
      console.error('Rapor API hatası:', reportError);
      apiError = reportError;
      // Burada hata fırlatmıyoruz - basit raporu kullanacağız
    }

    // Fallback - API hatası varsa basit bir rapor oluştur
    if (!reportData && simpleData.messages && simpleData.messages.length > 0) {
      console.log('Basit rapor oluşturuluyor (API hatası nedeniyle)');
      
      // Mesajlardan basit istatistikler oluştur
      const participants = {};
      let totalWords = 0;
      
      simpleData.messages.forEach(message => {
        if (!participants[message.userName]) {
          participants[message.userName] = {
            user_name: message.userName,
            message_count: 0,
            word_count: 0
          };
        }
        
        // Mesaj sayısını artır
        participants[message.userName].message_count++;
        
        // Kelime sayısını hesapla
        const wordCount = message.translations
          .find(t => t.languageId === userLang)?.text
          .split(/\s+/).length || 0;
          
        participants[message.userName].word_count += wordCount;
        totalWords += wordCount;
      });
      
      // İlk ve son mesaj saatlerini al
      const firstMessage = simpleData.messages[simpleData.messages.length - 1];
      const lastMessage = simpleData.messages[0];
      
      const startTime = new Date(firstMessage.createdAt);
      const endTime = new Date(lastMessage.createdAt);
      const durationMinutes = Math.round((endTime - startTime) / 60000);
      
      // Basit rapor verisi oluştur
      reportData = {
        success: true,
        data: {
          stats: {
            total_participants: Object.keys(participants).length,
            total_messages: simpleData.messages.length,
            total_words: totalWords,
            duration: durationMinutes
          },
          participants: Object.values(participants),
          summary: userLang === 'tr-TR' 
            ? `API'den özet alınamadı. Bu basit istatistiklerle oluşturulan otomatik rapordur. Toplantıda ${Object.keys(participants).length} katılımcı bulunmaktadır ve toplam ${simpleData.messages.length} mesaj paylaşılmıştır.`
            : `Could not get summary from API. This is an automatically generated report with basic statistics. There are ${Object.keys(participants).length} participants in the meeting and a total of ${simpleData.messages.length} messages have been shared.`,
          generatedAt: new Date().toISOString()
        }
      };
    }

    // Rapor verisi yoksa hata fırlat
    if (!reportData || !reportData.data) {
      throw new Error('Rapor verileri alınamadı. Lütfen daha sonra tekrar deneyin.');
    }

    const { data } = reportData;
    console.log('İşlenmiş rapor verisi:', data);

    // Toplantı ismi
    const meetingName = currentMeeting?.subject || 'CSC Voice AI - Generated Meeting Session Report';

    // HTML rapor şablonu
    const htmlContent = `
    <!DOCTYPE html>
    <html lang="${userLang.split('-')[0]}">
    <head>
      <meta charset="UTF-8">
      <title>${meetingName} - ${translations.title}</title>
        <style>
          body { 
            font-family: Arial, sans-serif; 
            margin: 40px; 
            line-height: 1.6;
            color: #333;
            background-color: #f8f9fa;
          }
          .header { 
            text-align: center; 
            margin-bottom: 30px;
            padding: 20px;
            background: #fff;
            border-radius: 8px;
            border-bottom: 3px solid #6264A7;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          }
          .header h1 {
            color: #6264A7;
            margin-bottom: 10px;
          }
          .header .meeting-meta {
            display: flex;
            justify-content: center;
            gap: 20px;
            font-size: 0.9em;
            margin-top: 10px;
          }
          .meeting-meta .meta-item {
            display: flex;
            align-items: center;
            gap: 5px;
          }
          .meeting-meta .meta-item i {
            color: #6264A7;
          }
          .header .error-note {
            color: #dc3545;
            padding: 10px;
            background-color: #f8d7da;
            border-radius: 4px;
            margin-top: 15px;
            font-size: 14px;
            display: ${apiError ? 'block' : 'none'};
          }
          .summary-section {
            margin: 20px 0;
            padding: 20px;
            background: #fff;
            border-radius: 8px;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          }
          .summary-section h2, 
          .summary-section h3 {
            color: #6264A7;
            border-bottom: 1px solid #eee;
            padding-bottom: 10px;
            margin-top: 20px;
          }
          .summary-section ul {
            list-style-type: none;
            padding-left: 0;
          }
          .summary-section ul li {
            margin: 10px 0;
            padding-left: 20px;
            position: relative;
          }
          .summary-section ul li:before {
            content: "•";
            color: #6264A7;
            font-weight: bold;
            position: absolute;
            left: 0;
          }
          .stats { 
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
            gap: 20px;
            margin: 20px 0;
          }
          .stat-box {
            background: #fff;
            padding: 20px;
            border-radius: 8px;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
            text-align: center;
          }
          .stat-box h3 {
            color: #6264A7;
            margin-top: 0;
            margin-bottom: 10px;
            font-size: 16px;
          }
          .stat-box p {
            font-size: 24px;
            font-weight: bold;
            margin: 0;
            color: #2c3e50;
          }
          .table-container {
            margin: 20px 0;
            padding: 20px;
            background: #fff;
            border-radius: 8px;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          }
          table { 
            width: 100%;
            border-collapse: collapse;
            margin: 20px 0;
          }
          th, td { 
            border: 1px solid #dee2e6;
            padding: 12px;
            text-align: left;
          }
          th { 
            background-color: #f8f9fa;
            font-weight: bold;
            color: #6264A7;
          }
          tr:nth-child(even) {
            background-color: #f8f9fa;
          }
          .footer {
            text-align: center;
            margin-top: 40px;
            padding: 20px;
            background: #fff;
            border-radius: 8px;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
            color: #666;
          }
          @media print {
            body { background: white; }
            .summary-section, .table-container, .stat-box {
              box-shadow: none;
              border: 1px solid #eee;
            }
            .header .error-note {
              display: none;
            }
          }
          .mood-bars {
            padding: 10px 0;
          }
          
          .mood-bar {
            margin: 8px 0;
          }
          
          .progress {
            height: 20px;
            background-color: #f5f5f5;
            border-radius: 4px;
            overflow: hidden;
          }
          
          .progress-bar {
            height: 100%;
            color: white;
            text-align: center;
            line-height: 20px;
            transition: width 0.6s ease;
          }
          
          .reaction-list {
            display: flex;
            flex-wrap: wrap;
            gap: 10px;
            margin: 10px 0;
          }
          
          .reaction-item {
            background: #f8f9fa;
            padding: 5px 10px;
            border-radius: 20px;
            display: flex;
            align-items: center;
            gap: 5px;
          }
          
          .keyword-cloud {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
            margin: 15px 0;
          }
          
          .keyword-tag {
            background: #e9ecef;
            padding: 4px 12px;
            border-radius: 15px;
            font-size: 0.9em;
          }
    
          .action-items {
            margin: 15px 0;
          }
          
          .action-item {
            background: #f8f9fa;
            border-left: 3px solid #6264A7;
            padding: 10px 15px;
            margin: 10px 0;
            border-radius: 0 4px 4px 0;
          }
          
          .action-item .title {
            font-weight: bold;
            color: #6264A7;
          }
          
          .action-item .owner {
            font-size: 0.9em;
            color: #6c757d;
            margin-top: 5px;
          }
    
          .sentiment-chart {
            width: 100%;
            height: 250px;
            margin: 20px 0;
          }
    
          .engagement-analysis {
            padding: 15px;
            background: #f8f9fa;
            border-radius: 8px;
            margin: 10px 0;
          }
    
          .topics-section ul {
            padding-left: 20px;
          }
    
          .topics-section li {
            margin-bottom: 10px;
          }
    
          .conflict-analysis {
            background: #fff3cd;
            border-left: 3px solid #ffc107;
            padding: 10px 15px;
            margin: 10px 0;
            border-radius: 0 4px 4px 0;
          }
    
          .decisions-section h4 {
            color: #6264A7;
            margin: 15px 0 5px;
          }
    
          .consensus-groups {
            padding: 10px;
            background: #e9ecef;
            border-radius: 4px;
            margin: 10px 0;
          }
        </style>
      </head>
    <body>
      <div class="header">
        <h1>${meetingName}</h1>
        <p>${translations.title}</p>
        <div class="meeting-meta">
          <div class="meta-item">
            <i class="bi bi-calendar"></i>
            <span>${translations.generatedAt}: ${new Date().toLocaleString(userLang)}</span>
          </div>
          ${selectedIndustry ? `
          <div class="meta-item">
            <i class="bi bi-building"></i>
            <span>${INDUSTRY_SECTORS.find(s => s.id === selectedIndustry)?.icon || '🏢'} ${INDUSTRY_SECTORS.find(s => s.id === selectedIndustry)?.name || selectedIndustry}</span>
          </div>
          ` : ''}
          ${selectedDepartment ? `
          <div class="meta-item">
            <i class="bi bi-people"></i>
            <span>${DEPARTMENTS.find(d => d.id === selectedDepartment)?.icon || '👥'} ${DEPARTMENTS.find(d => d.id === selectedDepartment)?.name || selectedDepartment}</span>
          </div>
          ` : ''}
        </div>
        <div class="error-note">
          ${apiError ? (userLang === 'tr-TR' ? 
            `Rapor oluşturulurken bir hata oluştu: ${apiError.message}. Bazı detaylar sınırlı olabilir.` :
            `An error occurred while creating the report: ${apiError.message}. Some details may be limited.`) : ''}
        </div>
      </div>
    
      ${data.summary ? `
        <div class="summary-section">
          <h2>${translations.summary}</h2>
          ${data.summary.replace(/### /g, '<h3>').replace(/\n/g, '<br>')}
        </div>
      ` : ''}
    
      <div class="stats">
        <div class="stat-box">
          <h3>${translations.stats.totalParticipants}</h3>
          <p>${data.stats.total_participants || 0}</p>
        </div>
        <div class="stat-box">
          <h3>${translations.stats.totalMessages}</h3>
          <p>${data.stats.total_messages || 0}</p>
        </div>
        <div class="stat-box">
          <h3>${translations.stats.totalWords}</h3>
          <p>${data.stats.total_words || 0}</p>
        </div>
        <div class="stat-box">
          <h3>${translations.stats.duration}</h3>
          <p>${data.stats.duration ? `${data.stats.duration} ${translations.stats.minutes}` : '-'}</p>
        </div>
      </div>
    
      ${data.keywords?.length > 0 ? `
        <div class="summary-section">
          <h2>${userLang === 'tr-TR' ? 'Anahtar Kelimeler' : 'Keywords'}</h2>
          <div class="keyword-cloud">
            ${data.keywords.map(keyword => `<span class="keyword-tag">${keyword}</span>`).join('')}
          </div>
        </div>
      ` : ''}
    
      ${data.actionItems ? `
        <div class="summary-section">
          <h2>${userLang === 'tr-TR' ? 'Eylem Maddeleri' : 'Action Items'}</h2>
          <div class="action-items">
            ${data.actionItems.replace(/\n/g, '<br>')}
          </div>
        </div>
      ` : ''}
    
      ${data.topicAnalysis ? `
        <div class="summary-section topics-section">
          <h2>${userLang === 'tr-TR' ? 'Toplantı Konuları' : 'Meeting Topics'}</h2>
          <div>
            ${data.topicAnalysis.replace(/\n/g, '<br>')}
          </div>
        </div>
      ` : ''}
    
      ${data.topicRelevance ? `
        <div class="summary-section">
          <h2>${userLang === 'tr-TR' ? 'Konu İlgililiği Analizi' : 'Topic Relevance Analysis'}</h2>
          <div>
            ${data.topicRelevance.replace(/\n/g, '<br>')}
          </div>
        </div>
      ` : ''}
    
      ${data.conflictAnalysis ? `
        <div class="summary-section">
          <h2>${userLang === 'tr-TR' ? 'Tartışma Analizi' : 'Conflict Analysis'}</h2>
          <div class="conflict-analysis">
            ${data.conflictAnalysis.replace(/\n/g, '<br>')}
          </div>
        </div>
      ` : ''}
    
      ${data.decisionsAndConsensus ? `
        <div class="summary-section decisions-section">
          <h2>${userLang === 'tr-TR' ? 'Kararlar ve Fikir Birliği' : 'Decisions and Consensus'}</h2>
          <div>
            ${data.decisionsAndConsensus.replace(/\n/g, '<br>')}
          </div>
        </div>
      ` : ''}
    
      <div class="table-container">
        <h2>${translations.participants.title}</h2>
        ${data.participants && data.participants.length > 0 ? `
          <table>
            <thead>
              <tr>
                <th>${translations.participants.columns.name}</th>
                <th>${translations.participants.columns.messageCount}</th>
                <th>${translations.participants.columns.wordCount}</th>
                <th>${translations.participants.columns.participation}</th>
              </tr>
            </thead>
            <tbody>
              ${data.participants.map(p => `
                <tr>
                  <td>${p.user_name}</td>
                  <td>${p.message_count}</td>
                  <td>${p.word_count}</td>
                  <td>${Math.round((p.message_count / (data.stats.total_messages || 1)) * 100)}%</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        ` : `<p>${userLang === 'tr-TR' ? 'Katılımcı verisi bulunamadı.' : 'No participant data found.'}</p>`}
      </div>
    
      ${data.participants?.some(p => p.engagement) ? `
        <div class="summary-section">
          <h2>${userLang === 'tr-TR' ? 'Katılımcı Katılım Analizi' : 'Participant Engagement Analysis'}</h2>
          ${data.participants.filter(p => p.engagement).map(p => `
            <div class="engagement-analysis">
              <h3>${p.user_name}</h3>
              <div>${p.engagement}</div>
            </div>
          `).join('')}
        </div>
      ` : ''}
    
      ${data.participantSentiments ? `
        <div class="summary-section">
          <h2>${userLang === 'tr-TR' ? 'Katılımcı Duygu Durumları' : 'Participant Sentiment Analysis'}</h2>
          <div class="stats">
            ${Object.entries(data.participantSentiments).map(([name, sentiment]) => `
              <div class="stat-box">
                <h3>${name}</h3>
                <p style="font-size: 18px">
                  ${sentiment.trend === 'pozitif' || sentiment.trend === 'positive' ? '😀' : 
                    sentiment.trend === 'negatif' || sentiment.trend === 'negative' ? '😞' : '😐'}
                  ${sentiment.average}/10
                </p>
                <div style="font-size: 0.9em; margin-top: 10px;">${sentiment.description}</div>
              </div>
            `).join('')}
          </div>
        </div>
      ` : ''}
    
      ${data.mood ? `
        <div class="mood-section summary-section">
          <h2>${translations.mood.title}</h2>
          <div class="stats mood-stats">
            <div class="stat-box">
              <h3>${translations.mood.ambiance}</h3>
              <p>${data.mood.ambiance || (userLang === 'tr-TR' ? 'Nötr' : 'Neutral')}</p>
            </div>
            <div class="stat-box">
              <h3>${translations.mood.overall}</h3>
              <p>
                ${translations.mood.positive}: ${data.mood.overall?.positive || 0} |
                ${translations.mood.neutral}: ${data.mood.overall?.neutral || 0} |
                ${translations.mood.negative}: ${data.mood.overall?.negative || 0}
              </p>
            </div>
          </div>
          ${data.mood.reactions?.length > 0 ? `
            <div class="reactions">
              <h3>${translations.mood.reactions}</h3>
              <div class="reaction-list">
                ${Array.from(new Set(data.mood.reactions || [])).join(' ')}
              </div>
            </div>
          ` : ''}
        </div>
      ` : ''}
    
      <div class="footer">
        <p>${translations.footer.generatedBy}</p>
        <p>${new Date().getFullYear()} ${translations.footer.copyright}</p>
      </div>
    </body>
    </html>
    `;

    // Raporu indir
    const blob = new Blob([htmlContent], { type: 'text/html;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${meetingName.replace(/[^a-z0-9]/gi, '_')}_${translations.title.replace(/\s+/g, '_')}_${new Date().toLocaleDateString(userLang)}.html`;
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    console.log('Rapor başarıyla oluşturuldu');

    // İşlem tamamlandı mesajı
    const successMessage = document.createElement('div');
    successMessage.className = 'alert alert-success';
    successMessage.innerHTML = `
      <div class="d-flex align-items-center">
        <i class="bi bi-check-circle-fill me-2"></i>
        <span>${userLang === 'tr-TR' ? 'Rapor başarıyla oluşturuldu!' : 'Report successfully created!'}</span>
      </div>
    `;
    
    if (messagesContainer) {
      messagesContainer.replaceChild(successMessage, loadingIndicator);
      setTimeout(() => {
        try { messagesContainer.removeChild(successMessage); } catch (e) {}
      }, 5000);
    }

  } catch (error) {
    console.error('Rapor oluşturma hatası:', {
      error: error.message,
      stack: error.stack,
      name: error.name
    });
    
    // Yükleme göstergesini kaldır
    try {
      const messagesContainer = document.querySelector('.messages-container');
      if (messagesContainer && loadingIndicator.parentNode === messagesContainer) {
        messagesContainer.removeChild(loadingIndicator);
      }
    } catch (e) {}
    
    setError(`Rapor oluşturulamadı: ${error.message}`);
    
    // Hata loglama
    try {
      await logError(error, {
        functionName: 'generateSessionSummary',
        details: {
          meetingId: meetingId || sessionId,
          selectedLanguage,
          industry: selectedIndustry,
          department: selectedDepartment
        }
      });
    } catch (logError) {
      console.error('Hata loglanırken hata oluştu:', logError);
    }
  }
};

  // İçerik raporu gönderme
  const handleReportSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const currentMeetingId = meetingId || sessionId;
    const currentUserId = teamsUserId || user?.id || 'guest';
    
    // Hata mesajını resetle
    setError('');
    
    try {
      if (!reportReason || !reportDescription) {
        setError('Lütfen tüm alanları doldurun');
        return;
      }
  
      const response = await apiCall('/api/content-reports', {
        method: 'POST',
        body: JSON.stringify({
          meetingId: currentMeetingId,
          userId: currentUserId,
          userName: user?.displayName || userName,
          messageId: selectedMessage.id,
          reason: reportReason,
          description: reportDescription,
          reportedAt: new Date().toISOString()
        })
      });
  
      if (response.success) {
        // Modal'ı kapat
        setReportModalOpen(false);
        
        // Form alanlarını temizle
        setReportReason('');
        setReportDescription('');
        setSelectedMessage(null);
        
        // Başarı bildirimi oluştur
        const successAlert = document.createElement('div');
        successAlert.className = 'alert alert-success position-fixed top-0 start-50 translate-middle-x mt-3';
        successAlert.style.zIndex = '1050';
        successAlert.innerHTML = `
          <div class="d-flex align-items-center">
            <i class="bi bi-check-circle-fill me-2"></i>
            Rapor başarıyla gönderildi.
          </div>
        `;
        
        // Bildirimi sayfaya ekle
        document.body.appendChild(successAlert);
        
        // Bildirimi 3 saniye sonra kaldır
        setTimeout(() => {
          if (successAlert.parentNode) {
            successAlert.parentNode.removeChild(successAlert);
          }
        }, 3000);
      } else {
        throw new Error(response.error || 'Rapor gönderilemedi');
      }
    } catch (error) {
      console.error('Rapor gönderme hatası:', error);
      logError(error, { context: 'handleReportSubmit' });
      setError(`Rapor gönderilemedi: ${error.message}`);
    }
  };

  // Tema değişikliği dinleyicisi
  useEffect(() => {
    const handleThemeChange = (e) => {
      if (e.data && e.data.type === 'themeChange') {
        setTheme(e.data.theme || 'default');
      }
    };

    window.addEventListener('message', handleThemeChange);
    return () => {
      window.removeEventListener('message', handleThemeChange);
    };
  }, []);

  // Uygulama başlatma
  useEffect(() => {
    const initializeApp = async () => {
      setIsInitializing(true);
      console.log('Uygulama başlatılıyor...');

      try {
        const isSpeechReady = await checkSpeechService();
        if (!isSpeechReady) {
          throw new Error('Speech servisi başlatılamadı');
        }

        if (user?.displayName) {
          setUserName(user.displayName);
        }

        const hasMicPermission = await checkMicrophonePermission();
        if (!hasMicPermission) {
          throw new Error('Mikrofon izni alınamadı');
        }

        setIsInitializing(false);
        console.log('Uygulama başarıyla başlatıldı');

      } catch (err) {
        console.error('Başlatma hatası:', err);
        logError(err, { context: 'initializeApp' });
        setError(`Başlatma hatası: ${err.message}`);
        setIsInitializing(false);
      }
    };

    initializeApp();

    return () => {
      if (isListening) {
        stopListening();
      }
      if (messagePollingInterval.current) {
        clearInterval(messagePollingInterval.current);
      }
      if (displayTimeoutRef.current) {
        clearTimeout(displayTimeoutRef.current);
      }
    };
  }, [checkSpeechService, checkMicrophonePermission, stopListening, isListening, user, setUserName]);

  // Mesaj yoklama
  useEffect(() => {
    if (isListening) {
      displayNextMessage();
      
      messagePollingInterval.current = setInterval(fetchNewMessages, 500);
      
      return () => {
        if (messagePollingInterval.current) {
          clearInterval(messagePollingInterval.current);
        }
        if (displayTimeoutRef.current) {
          clearTimeout(displayTimeoutRef.current);
        }
      };
    }
  }, [isListening, displayNextMessage, fetchNewMessages]);

  return (
    
    <div className="voice-translator-container" style={{
      backgroundColor: themeColors[theme].background,
      color: themeColors[theme].text
    }}>
      <div className="voice-header" style={{
        backgroundColor: themeColors[theme].navBg,
        borderBottom: `1px solid ${themeColors[theme].border}`,
        boxShadow: `0 2px 4px ${themeColors[theme].shadow}`
      }}>
        {/* Toplantı konusu başlığı - Yeni eklenen bölüm */}
  {meetingSubject && (
    <div className="meeting-subject-header" style={{
      backgroundColor: themeColors[theme].primary,
      padding: '8px 15px',
      color: 'white',
      borderRadius: '4px',
      marginBottom: '10px',
      fontSize: '14px',
      fontWeight: 'bold',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <i className="bi bi-calendar-event" style={{ marginRight: '8px' }}></i>
      {decodeURIComponent(meetingSubject)}
    </div>
  )}

        <div className="controls-area">
        <select
          value={selectedLanguage}
          onChange={handleLanguageChange}
          disabled={isListening}
          className="language-select"
          style={{ 
            backgroundColor: '#6264A7', // Header ile aynı renk
            color: 'white',
            border: '1px solid rgba(42, 25, 195, 0.2)',
            fontWeight: 'bold',
            minWidth: '80px'
          }}
        >
          {SUPPORTED_LANGUAGES.map(lang => (
            <option key={lang.code} value={lang.code}>
              {lang.icon} {lang.name}
            </option>
          ))}
        </select>

        {/* Yeni: Sektör seçimi */}
        <select
          value={selectedIndustry}
          onChange={handleIndustryChange}
          className="language-select" // Aynı stili kullanıyoruz
          style={{ 
            backgroundColor: '#6264A7',
            color: 'white',
            border: '1px solid rgba(42, 25, 195, 0.2)',
            fontWeight: 'bold',
            minWidth: '80px'
          }}
        >
          {INDUSTRY_SECTORS.map(sector => (
            <option key={sector.id} value={sector.id}>
              {sector.icon} {sector.name}
            </option>
          ))}
        </select>

        {/* Yeni: Departman seçimi */}
        <select
          value={selectedDepartment}
          onChange={handleDepartmentChange}
          className="language-select" // Aynı stili kullanıyoruz
          style={{ 
            backgroundColor: '#6264A7',
            color: 'white',
            border: '1px solid rgba(42, 25, 195, 0.2)',
            fontWeight: 'bold',
            minWidth: '80px'
          }}
        >
          {DEPARTMENTS.map(dept => (
            <option key={dept.id} value={dept.id}>
              {dept.icon} {dept.name}
            </option>
          ))}
        </select>

          <div className="button-group">
            <button
              onClick={startListening}
              disabled={isListening || !micPermission || !speechServiceReady || buttonsDisabled}
              className={`control-button ${isListening ? 'listening' : ''}`}
              style={{ 
                backgroundColor: isListening ? '#6c757d' : themeColors[theme].primary,
                color: '#ffffff',
                border: 'none',
                boxShadow: '0 2px 5px #6264A7'
                
              }}
            >
              {isListening ? (
                <>
                  <span className="listening-indicator"></span>
                  Listening
                </>
              ) : (
                <>
                  <i className="bi bi-mic-fill me-1"></i>
                  Listen
                </>
              )}
            </button>
            <button
              onClick={stopListening}
              disabled={!isListening || buttonsDisabled}
              className="control-button stop-button"
              style={{ 
                backgroundColor: themeColors[theme].primary,
                color: '#ffffff',
                border: 'none',
                boxShadow: '0 2px 5px #6264A7'
              }}
            >
              <i className="bi bi-stop-fill"></i> Stop
            </button>
          </div>

          <button
            onClick={generateSessionSummary}
            disabled={!sessionId || buttonsDisabled}
            className="control-button"
            style={{ 
              backgroundColor: themeColors[theme].primary,
              color: '#ffffff',
              border: 'none',
              boxShadow: '0 2px 5px #6264A7'
            }}
          >
            <i className="bi bi-file-text"
            ></i> Generate AI Meeting Report
          </button>
        </div>
      </div>

      <div className="voice-content">
        {error && (
          <div className="error-alert" role="alert">
            <i className="bi bi-exclamation-triangle-fill me-2"></i>
            {error}
            {!micPermission && (
              <button onClick={checkMicrophonePermission} className="mic-permission-button">
                Microphone Permission
              </button>
            )}
          </div>
        )}

        <div className="messages-container">
          <center><span className="tagline">Real-time voice recognition and translation service for Teams</span></center>
          <div className="ai-notice" style={{color: themeColors[theme].muted}}>This is AI generated content</div>
          
          {displayedMessages.map((message, index) => {
            const colors = ['primary', 'success', 'info', 'warning', 'danger'];
            const colorClass = colors[index % colors.length];
            
            return (
              <div key={message.id} className={`message-card border-${colorClass}`} style={{
                backgroundColor: themeColors[theme].cardBg,
                borderColor: themeColors[theme].border,
                color: themeColors[theme].text
              }}>
                <div className="message-header" style={{
                  backgroundColor: themeColors[theme].messageHeader,
                  borderBottom: `1px solid ${themeColors[theme].border}`
                }}>
                  <div className="message-user-info">
                    <div className={`user-avatar bg-${colorClass}`}>
                      {message.userName.charAt(0)}
                    </div>
                    <div className="user-details">
                      <div className="user-name">{message.userName}</div>
                      <div className="message-meta">
                        {SUPPORTED_LANGUAGES.find(l => l.code === message.sourceLanguageId)?.icon}
                        {' '}Message Time:
                        {new Date(message.createdAt).toLocaleTimeString('tr-TR', {
                          hour: '2-digit',
                          minute: '2-digit'
                        })}
                      </div>
                    </div>
                  </div>
                  <button
                    onClick={() => handleReportClick(message)}
                    className="report-icon-button"
                    title="Report inappropriate content"
                    style={{color: themeColors[theme].muted}}
                  >
                    <i className="bi bi-flag"></i>
                  </button>
                </div>
                <div className="message-body">
                {(() => {
                  // API'den gelen çevirileri göster
                  if (message.translations && message.translations.length > 0) {
                    return message.translations.map((translation, index) => {
                      // Boş metin kontrolü
                      if (!translation.text || translation.text.trim() === '') {
                        return (
                          <p key={index} className="message-text text-muted">
                            Çeviri içeriği boş.
                          </p>
                        );
                      }
                      
                      // Kodlanmış metni çözümleme (encoded text varsa)
                      let textToShow = translation.text;
                      try {
                        if (textToShow.includes('%')) {
                          textToShow = decodeURIComponent(textToShow);
                        }
                      } catch (e) {
                        console.warn('Metin çözümleme hatası:', e);
                      }
                      
                      return (
                        <p key={index} className="message-text">
                          {textToShow}
                        </p>
                      );
                    });
                  }
                  
                  return (
                    <p className="message-text text-muted">
                      Bu mesaj için çeviri bulunamadı.
                    </p>
                  );
                })()}
              </div>
              </div>
            );
          })}

          {displayedMessages.length === 0 && !isInitializing && (
            <div className="empty-state">
              <div className="empty-icon" style={{color: themeColors[theme].muted}}>
                <i className="bi bi-chat-dots"></i>
              </div>
              <h6 className="empty-title">There is no translated message yet</h6>
              <p className="empty-message" style={{color: themeColors[theme].muted}}>
                The translated messages will appear here when the "Listen" button and conversation starts
              </p>
            </div>
          )}
        </div>
      </div>

      {/* Report Modal */}
      <div className={`report-modal ${reportModalOpen ? 'show' : ''}`}>
        <div className="modal-dialog">
          <div className="modal-content" style={{
            backgroundColor: themeColors[theme].modalBg,
            color: themeColors[theme].text,
            border: `1px solid ${themeColors[theme].border}`
          }}>
            <div className="modal-header" style={{
              backgroundColor: themeColors[theme].messageHeader,
              borderBottom: `1px solid ${themeColors[theme].border}`
            }}>
              <h5 className="modal-title">Report Inappropriate Content</h5>
              <button 
                type="button" 
                className="close-button" 
                onClick={handleModalClose}
              >
                <i className="bi bi-x"></i>
              </button>
              <button 
                type="button" 
                className="cancel-button"
                onClick={handleModalClose}
              >
                <i className="bi bi-x"></i>
              </button>
              
            </div>
            <form onSubmit={handleReportSubmit}>
              <div className="modal-body">
                {error && (
                  <div className="alert alert-danger" role="alert">
                    {error}
                  </div>
                )}
                <div className="form-group">
                  <label>Reason for Report</label>
                  <select
                    value={reportReason}
                    onChange={(e) => {
                      setReportReason(e.target.value);
                      setError(''); // Hata mesajını temizle
                    }}
                    className="form-select"
                    required
                    style={{
                      backgroundColor: themeColors[theme].cardBg,
                      color: themeColors[theme].text,
                      border: `1px solid ${themeColors[theme].border}`
                    }}
                  >
                    <option value="">Select a reason...</option>
                    <option value="inappropriate">Inappropriate Content</option>
                    <option value="offensive">Offensive Language</option>
                    <option value="inaccurate">Inaccurate Translation</option>
                    <option value="hate_speech">Hate Speech</option>
                    <option value="misinformation">Misinformation</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Additional Details</label>
                  <textarea 
                    value={reportDescription}
                    onChange={(e) => {
                      setReportDescription(e.target.value);
                      setError(''); // Hata mesajını temizle
                    }}
                    className="form-textarea"
                    rows="3"
                    placeholder="Please provide more details about your report..."
                    required
                    style={{
                      backgroundColor: themeColors[theme].cardBg,
                      color: themeColors[theme].text,
                      border: `1px solid ${themeColors[theme].border}`
                    }}
                  ></textarea>
                </div>
                <div className="form-help" style={{color: themeColors[theme].muted}}>
                  <i className="bi bi-info-circle me-1"></i>
                  Your report will be reviewed by our team and appropriate action will be taken.
                </div>
              </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="cancel-button"
                  onClick={() => {
                    setReportModalOpen(false);
                    setSelectedMessage(null);
                    setReportReason('');
                    setReportDescription('');
                    setError('');
                  }}
                  style={{
                    backgroundColor: '#6c757d',
                    color: '#ffffff',
                    border: 'none'
                  }}
                >
                  Cancel
                </button>
                <button 
                  type="submit" 
                  className="submit-button" 
                  style={{
                    backgroundColor: themeColors[theme].primary,
                    color: '#ffffff',
                    border: 'none'
                  }}
                >
                  Submit Report
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {reportModalOpen && (
  <div 
    className="modal-backdrop" 
    onClick={(e) => {
      if (e.target === e.currentTarget) {
        setReportModalOpen(false);
        setSelectedMessage(null);
        setReportReason('');
        setReportDescription('');
        setError('');
      }
    }}
  ></div>
)}

      <div className="footer-bar" style={{
        backgroundColor: themeColors[theme].primary,
        borderTop: `1px solid ${themeColors[theme].border}`,
        color: '#ffffff'
      }}>
        <a href="https://www.cscvoice.ai" 
           target="_blank" 
           rel="noopener noreferrer" 
           className="footer-link">
          © 2025 CSC Voice AI - www.cscvoice.ai
        </a>
      </div>
    </div>
  );
};

export default WebVoiceTranslator;